  // import React, { useState, useEffect } from "react";
  // import {
  //   Box,
  //   Card,
  //   CardContent,
  //   Typography,
  //   Avatar,
  //   IconButton,
  //   Container,
  //   Skeleton,
  //   Chip,
  //   Zoom,
  //   useTheme,
  //   useMediaQuery,
  //   ThemeProvider,
  //   createTheme,
  //   CssBaseline,
  //   LinearProgress,
  //   Alert,
  //   Dialog,
  //   DialogTitle,
  //   DialogContent,
  //   DialogActions,
  //   Select,
  //   MenuItem,
  //   FormControl,
  //   InputLabel,
  //   Stack,
  //   Tooltip,
  //   Button, // ADDED THIS IMPORT
  // } from "@mui/material";
  // import {
  //   Dashboard as DashboardIcon,
  //   Description as DocumentIcon,
  //   PendingActions as PendingIcon,
  //   Chat as ChatIcon,
  //   Notifications as NotificationIcon,
  //   Settings as SettingsIcon,
  //   Assessment as AssessmentIcon,
  //   Timeline as TimelineIcon,
  //   BarChart as BarChartIcon,
  //   Refresh as RefreshIcon,
  //   Close as CloseIcon,
  // } from "@mui/icons-material";
  // import DashboardServices from "../services/dashboardServices";
  // import { toast, ToastContainer } from "react-toastify";
  // import Loader from "../utils/loader";
  // import { useSelector } from "react-redux";
  // import { Link } from "react-router-dom";
  // import { getnotifications } from "../services/notficationService";
  // import StatusApexChartsComp from "./ReusableComponents/StatusApexChartsComp";
  // import documentService from "../services/document";
  // import moment from "moment/moment";
  // import Grid2 from "@mui/material/Unstable_Grid2";

  // // Enhanced Material-UI Theme
  // const createCustomTheme = (isDarkMode) =>
  //   createTheme({
  //     palette: {
  //       mode: isDarkMode ? "dark" : "light",
  //       primary: {
  //         main: "#1976d2",
  //         light: "#42a5f5",
  //         dark: "#1565c0",
  //       },
  //       secondary: {
  //         main: "#9c27b0",
  //         light: "#ba68c8",
  //         dark: "#7b1fa2",
  //       },
  //       success: {
  //         main: "#2e7d32",
  //         light: "#4caf50",
  //         dark: "#1b5e20",
  //       },
  //       warning: {
  //         main: "#ed6c02",
  //         light: "#ff9800",
  //         dark: "#e65100",
  //       },
  //       error: {
  //         main: "#d32f2f",
  //         light: "#f44336",
  //         dark: "#c62828",
  //       },
  //       background: {
  //         default: isDarkMode ? "#0a0e1a" : "#f8fafc",
  //         paper: isDarkMode ? "#1a1f2e" : "#ffffff",
  //       },
  //       text: {
  //         primary: isDarkMode ? "#ffffff" : "#1a202c",
  //         secondary: isDarkMode ? "#a0aec0" : "#4a5568",
  //       },
  //     },
  //     typography: {
  //       fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
  //       h4: {
  //         fontWeight: 700,
  //         fontSize: "2.25rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       h5: {
  //         fontWeight: 600,
  //         fontSize: "1.75rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       h6: {
  //         fontWeight: 600,
  //         fontSize: "1.25rem",
  //         letterSpacing: "-0.025em",
  //       },
  //       subtitle1: {
  //         fontWeight: 500,
  //         fontSize: "1rem",
  //         lineHeight: 1.5,
  //       },
  //       body1: {
  //         fontSize: "0.875rem",
  //         lineHeight: 1.6,
  //       },
  //     },
  //     shape: {
  //       borderRadius: 16,
  //     },
  //     components: {
  //       MuiCard: {
  //         styleOverrides: {
  //           root: {
  //             boxShadow: isDarkMode
  //               ? "0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)"
  //               : "0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
  //             borderRadius: 20,
  //             transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //             border: isDarkMode
  //               ? "1px solid rgba(255,255,255,0.1)"
  //               : "1px solid rgba(0,0,0,0.05)",
  //             background: isDarkMode
  //               ? "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.05) 100%)"
  //               : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
  //             backdropFilter: "blur(20px)",
  //             "&:hover": {
  //               transform: "translateY(-8px) scale(1.02)",
  //               boxShadow: isDarkMode
  //                 ? "0 20px 60px rgba(0,0,0,0.5), 0 8px 16px rgba(0,0,0,0.3)"
  //                 : "0 20px 60px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.08)",
  //             },
  //           },
  //         },
  //       },
  //       MuiButton: {
  //         styleOverrides: {
  //           root: {
  //             borderRadius: 12,
  //             textTransform: "none",
  //             fontWeight: 600,
  //             padding: "10px 24px",
  //             boxShadow: "none",
  //             "&:hover": {
  //               boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
  //               transform: "translateY(-2px)",
  //             },
  //           },
  //         },
  //       },
  //       MuiPaper: {
  //         styleOverrides: {
  //           root: {
  //             backgroundImage: "none",
  //           },
  //         },
  //       },
  //     },
  //   });

  // // Enhanced Stat Card Component
  // const StatCard = ({ title, value, icon, color, trend, isLoading, onClick }) => {
  //   const theme = useTheme();

  //   return (
  //     <Zoom in={!isLoading} style={{ transitionDelay: "100ms" }}>
  //       <Card
  //         sx={{
  //           height: "100%",
  //           cursor: onClick ? "pointer" : "default",
  //           background: `linear-gradient(135deg, ${color}15 0%, ${color}08 50%, ${color}03 100%)`,
  //           border: `2px solid ${color}20`,
  //           position: "relative",
  //           overflow: "hidden",
  //           "&:hover": onClick
  //             ? {
  //                 transform: "translateY(-8px) scale(1.02)",
  //                 boxShadow: `0 20px 40px ${color}25`,
  //                 border: `2px solid ${color}40`,
  //               }
  //             : {},
  //           "&::before": {
  //             content: '""',
  //             position: "absolute",
  //             top: -50,
  //             right: -50,
  //             width: "150px",
  //             height: "150px",
  //             background: `radial-gradient(circle, ${color}20 0%, transparent 70%)`,
  //             borderRadius: "50%",
  //           },
  //           "&::after": {
  //             content: '""',
  //             position: "absolute",
  //             bottom: -30,
  //             left: -30,
  //             width: "100px",
  //             height: "100px",
  //             background: `linear-gradient(45deg, ${color}10, transparent)`,
  //             borderRadius: "50%",
  //           },
  //         }}
  //         onClick={onClick}
  //       >
  //         <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
  //           <Box
  //             sx={{
  //               display: "flex",
  //               alignItems: "center",
  //               justifyContent: "space-between",
  //               mb: 3,
  //             }}
  //           >
  //             <Avatar
  //               sx={{
  //                 bgcolor: `${color}25`,
  //                 color: color,
  //                 width: 64,
  //                 height: 64,
  //                 boxShadow: `0 8px 20px ${color}30`,
  //               }}
  //             >
  //               {icon}
  //             </Avatar>
  //             {trend && (
  //               <Chip
  //                 label={trend}
  //                 size="small"
  //                 sx={{
  //                   bgcolor: trend.includes("+")
  //                     ? theme.palette.success.main
  //                     : theme.palette.error.main,
  //                   color: "white",
  //                   fontWeight: 700,
  //                   boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //                 }}
  //               />
  //             )}
  //           </Box>

  //           {isLoading ? (
  //             <Box>
  //               <Skeleton variant="text" width="60%" height={36} />
  //               <Skeleton variant="text" width="40%" height={28} />
  //             </Box>
  //           ) : (
  //             <Box>
  //               <Typography
  //                 variant="h4"
  //                 component="div"
  //                 sx={{
  //                   fontWeight: 800,
  //                   color: color,
  //                   mb: 1,
  //                   textShadow: `0 2px 4px ${color}20`,
  //                 }}
  //               >
  //                 {value}
  //               </Typography>
  //               <Typography
  //                 variant="subtitle1"
  //                 color="text.Primary"
  //                 sx={{ fontWeight: 600, opacity: 0.8 }}
  //               >
  //                 {title}
  //               </Typography>
  //             </Box>
  //           )}
  //         </CardContent>
  //       </Card>
  //     </Zoom>
  //   );
  // };

  // // Enhanced Chart Container Component
  // const ChartContainer = ({
  //   title,
  //   children,
  //   actions,
  //   isLoading,
  //   height = 400,
  //   icon,
  //   gradientColors,
  // }) => {
  //   const theme = useTheme();

  //   return (
  //     <Card
  //       sx={{
  //         height: "100%",
  //         display: "flex",
  //         flexDirection: "column",
  //         background: gradientColors
  //           ? `linear-gradient(135deg, ${gradientColors[0]}08 0%, ${gradientColors[1]}05 50%, ${gradientColors[0]}03 100%)`
  //           : undefined,
  //         border: gradientColors ? `1px solid ${gradientColors[0]}20` : undefined,
  //       }}
  //     >
  //       <CardContent
  //         sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 3 }}
  //       >
  //         <Box
  //           sx={{
  //             display: "flex",
  //             alignItems: "center",
  //             justifyContent: "space-between",
  //             mb: 3,
  //             pb: 2,
  //             borderBottom: `1px solid ${theme.palette.divider}`,
  //           }}
  //         >
  //           <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  //             {icon && (
  //               <Avatar
  //                 sx={{
  //                   bgcolor: gradientColors
  //                     ? `${gradientColors[0]}20`
  //                     : "primary.light",
  //                   color: gradientColors ? gradientColors[0] : "primary.main",
  //                   width: 48,
  //                   height: 48,
  //                 }}
  //               >
  //                 {icon}
  //               </Avatar>
  //             )}
  //             <Typography
  //               variant="h6"
  //               component="h2"
  //               sx={{
  //                 fontWeight: 700,
  //                 color: gradientColors ? gradientColors[0] : "text.primary",
  //                 textShadow: gradientColors
  //                   ? `0 1px 2px ${gradientColors[0]}20`
  //                   : undefined,
  //               }}
  //             >
  //               {title}
  //             </Typography>
  //           </Box>
  //           {actions && (
  //             <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
  //               {actions}
  //             </Box>
  //           )}
  //         </Box>

  //         {isLoading ? (
  //           <Box
  //             sx={{
  //               flexGrow: 1,
  //               display: "flex",
  //               flexDirection: "column",
  //               justifyContent: "center",
  //             }}
  //           >
  //             <Skeleton
  //               variant="rectangular"
  //               height={height - 120}
  //               sx={{ borderRadius: 2 }}
  //             />
  //           </Box>
  //         ) : (
  //           <Box
  //             sx={{
  //               flexGrow: 1,
  //               display: "flex",
  //               flexDirection: "column",
  //               minHeight: height - 120,
  //             }}
  //           >
  //             {children}
  //           </Box>
  //         )}
  //       </CardContent>
  //     </Card>
  //   );
  // };

  // const DashboardPage = () => {
  //   const [loading, setLoading] = useState(false);
  //   const [selectYear, setSelectYear] = useState(new Date().getFullYear());
  //   const [selectMonth, setSelectMonth] = useState(new Date().getMonth() + 1);

  //   // FIXED: Updated years array to include current year (2026)
  //   const [years, setYears] = useState(() => {
  //     const currentYear = new Date().getFullYear();
  //     // Start from 2019 to current year (inclusive)
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push(year);
  //     }
  //     return yearsArray;
  //   });

  //   const [selected, setSelected] = useState(new Date().getFullYear());
  //   const [totalMyDocs, setTotalMyDocs] = useState(0);
  //   const [totalSharedDocs, setTotalSharedDocs] = useState(0);
  //   const [imageCardData, setImageCardData] = useState({
  //     totalDocuments: "0",
  //     pendingForApproval: "0",
  //     unreadMsgCount: "0",
  //   });
  //   const userDetails = useSelector((state) => state.user);
  //   const isGuest = localStorage.getItem("is_guest");

  //   const userID = userDetails?.currentUser?._id;

  //   const userRole = sessionStorage.getItem("Role");
  //   const [yearList, setYearList] = useState(() => {
  //     const currentYear = new Date().getFullYear();
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push({ name: year.toString(), value: year });
  //     }
  //     return yearsArray;
  //   });
  //   const [teamList, setTeamList] = useState([]);
  //   const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
  //   const [statusChartYear, setStatusChartYear] = useState(
  //     new Date().getFullYear(),
  //   );
  //   const [selectedMember, setSelectedMember] = useState();
  //   const [isBarChartDropdown, setIsBarChartDropdown] = useState(false);
  //   const [isPieChartDropdown, setIsPieChartDropdown] = useState(false);
  //   const [barChartData, setBarChartData] = useState({
  //     bar1Count: 0,
  //     bar2Count: 0,
  //     chartHeading: "Documents & Reviews",
  //     bar1Name: `Documents(0)`,
  //     bar2Name: `Reviews(0)`,
  //     xAxis: [
  //       "Jan",
  //       "Feb",
  //       "Mar",
  //       "Apr",
  //       "May",
  //       "June",
  //       "July",
  //       "Aug",
  //       "Sept",
  //       "Oct",
  //       "Nov",
  //       "Dec",
  //     ],
  //     bar1Datas: [],
  //     bar2Data: [],
  //   });
  //   const [barDocsStatusChartData, setBarDocsStatusChartData] = useState({
  //     chartHeading: "Documents & Reviews Status",
  //     bar1Name: "Documents",
  //     bar2Name: "Reviews",
  //     xAxis: ["Pending", "Progress", "Completed", "Rejected", "Published"],
  //     counts: [],
  //   });
  //   const [notifications, setNotifications] = useState([]);
  //   const [isDarkMode, setIsDarkMode] = useState(false);
  //   const screenData = useSelector(
  //     (state) => state.manageSubscriptionPlan.subscriptionPlan,
  //   );
  //   const [alertForEndSub, setAlertForEndSub] = useState("");
  //   const [showPopup, setShowPopup] = useState(false);

  //   const theme = createCustomTheme(isDarkMode);
  //   const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  //   const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

  //   // ✅ Guest demo data
  //   useEffect(() => {
  //     if (isGuest) {
  //       setTotalMyDocs(12);
  //       setTotalSharedDocs(4);

  //       setImageCardData({
  //         totalDocuments: "16",
  //         pendingForApproval: "3",
  //         unreadMsgCount: "5",
  //       });

  //       setBarChartData((prev) => ({
  //         ...prev,
  //         bar1Datas: [2, 3, 4, 5, 6, 4, 3, 2, 1, 3, 5, 4],
  //         bar2Data: [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 3, 2],
  //         bar1Count: 42,
  //         bar2Count: 22,
  //         bar1Name: "Documents(42)",
  //         bar2Name: "Reviews(22)",
  //       }));

  //       setBarDocsStatusChartData((prev) => ({
  //         ...prev,
  //         counts: [3, 5, 8, 2, 6],
  //       }));
  //     }
  //   }, [isGuest]);

  //   useEffect(() => {
  //     const alertShown = sessionStorage.getItem("subscriptionAlertShown");
  //     const roleOfUser = sessionStorage.getItem("Role");

  //     const checkSubscriptionExpiry = () => {
  //       if (
  //         !alertShown &&
  //         screenData?.isDefault == false &&
  //         roleOfUser == "Individual"
  //       ) {
  //         const now = moment().startOf("day");
  //         const expiryDate = moment(screenData?.endDate).startOf("day");
  //         const daysLeft = expiryDate.diff(now, "days");

  //         if (daysLeft >= 1 && daysLeft <= 5) {
  //           setAlertForEndSub(
  //             `Your subscription will expire in ${daysLeft} day(s) on ${expiryDate.format(
  //               "D MMMM YYYY",
  //             )}.`,
  //           );
  //           setShowPopup(true);
  //         } else if (daysLeft === 0) {
  //           setAlertForEndSub(
  //             `Your subscription expires today on ${expiryDate.format(
  //               "D MMMM YYYY",
  //             )}.`,
  //           );
  //           setShowPopup(true);
  //         } else {
  //           setAlertForEndSub("");
  //         }
  //         if ((daysLeft >= 1 && daysLeft <= 5) || daysLeft === 0) {
  //           sessionStorage.setItem("subscriptionAlertShown", "true");
  //         }
  //       }
  //     };

  //     checkSubscriptionExpiry();
  //   }, [screenData?.endDate]);

  //   const handleClose = () => {
  //     setShowPopup(false);
  //   };

  //   useEffect(() => {
  //     const updateTheme = () => {
  //       const theme = localStorage.getItem("ThemeSwitch");
  //       setIsDarkMode(theme === "true");
  //     };
  //     updateTheme();
  //     window.addEventListener("storage", updateTheme);
  //     const originalSetItem = localStorage.setItem;
  //     localStorage.setItem = function (key, value) {
  //       originalSetItem.apply(this, arguments);
  //       if (key === "ThemeSwitch") {
  //         updateTheme();
  //       }
  //     };
  //     return () => {
  //       window.removeEventListener("storage", updateTheme);
  //       localStorage.setItem = originalSetItem;
  //     };
  //   }, []);

  //   const { leftNavbarOpen } = useSelector(
  //     (state) => state.handleModelAndSideBavBar,
  //   );

  //   // Initialize year list dynamically
  //   useEffect(() => {
  //     const currentYear = new Date().getFullYear();
  //     const yearsArray = [];
  //     for (let year = 2019; year <= currentYear; year++) {
  //       yearsArray.push({ name: year.toString(), value: year });
  //     }
  //     setYearList(yearsArray);
  //     setYears(yearsArray.map((y) => y.value));
  //     setIsBarChartDropdown(true);
  //   }, []);

  //   // useEffect(() => {
  //   //   fetchYearList();
  //   //   getUserDashCardDetails();
  //   //   getUserBarChartDetails(barChartYear);
  //   // }, []);

  //   useEffect(() => {
  //     if (!isGuest) {
  //       fetchYearList();
  //       getUserDashCardDetails();
  //       getUserBarChartDetails(barChartYear);
  //     }
  //   }, [isGuest]);

  //   const fetchYearList = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getYearList();
  //       console.log("fetchYearList", response);
  //       if (response.status == 200) {
  //         // Ensure current year is included
  //         const currentYear = new Date().getFullYear();
  //         const serverYears = response.yearList || [];

  //         // Check if current year is in the list
  //         if (!serverYears.includes(currentYear)) {
  //           serverYears.push(currentYear);
  //           serverYears.sort((a, b) => a - b);
  //         }

  //         let finalArr = serverYears.map((year) => ({
  //           name: year.toString(),
  //           value: year,
  //         }));
  //         setYearList(finalArr);
  //         setYears(serverYears);
  //         setIsBarChartDropdown(true);
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //       // Fallback: create years array manually
  //       const currentYear = new Date().getFullYear();
  //       const yearsArray = [];
  //       for (let year = 2019; year <= currentYear; year++) {
  //         yearsArray.push(year);
  //       }
  //       const finalArr = yearsArray.map((year) => ({
  //         name: year.toString(),
  //         value: year,
  //       }));
  //       setYearList(finalArr);
  //       setYears(yearsArray);
  //       setIsBarChartDropdown(true);
  //     }
  //     setLoading(false);
  //   };

  //   const fetchTeamList = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getTeamMembersDetails(userID);
  //       console.log("fetchTeamList", response);
  //       let finalArr = [];
  //       response.memberNames.map((obj) =>
  //         finalArr.push({ name: obj.name, value: obj.id }),
  //       );
  //       setTeamList(finalArr);
  //       setIsPieChartDropdown(true);
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const getDocs = async () => {
  //     try {
  //       const response = await documentService.getAllMyDocuments();
  //       if (response.status === 200) {
  //         setTotalMyDocs(response.data.length);
  //       } else {
  //         console.error("Error fetching data:", response.message);
  //       }
  //     } catch (error) {
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   };

  //   const getSharedDocs = async () => {
  //     try {
  //       const response = await documentService.getSharedDocuments();
  //       if (response.status === 200) {
  //         setTotalSharedDocs(response.data.length);
  //       } else {
  //         console.error("Error fetching data:", response.message);
  //       }
  //     } catch (error) {
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   getDocs();
  //   //   getSharedDocs();
  //   // }, []);
  //   useEffect(() => {
  //     if (!isGuest) {
  //       getDocs();
  //       getSharedDocs();
  //     }
  //   }, [isGuest]);

  //   const getUserDashCardDetails = async () => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getIndividualDashCards(userID);
  //       console.log("getUserDashCardDetails", response);
  //       let { totalDocuments, pendingForApproval, unreadMsgCount } = response;
  //       setImageCardData({
  //         totalDocuments: totalDocuments,
  //         pendingForApproval: pendingForApproval,
  //         unreadMsgCount: unreadMsgCount,
  //       });
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const getUserBarChartDetails = async (year) => {
  //     setLoading(true);
  //     try {
  //       let response = await DashboardServices.getIndividualBarChart(
  //         userID,
  //         year,
  //       );
  //       console.log("getUserBarChartDetails", response);
  //       let { bar1, bar2, bar1Count, bar2Count } = response;
  //       setBarChartData((prevState) => ({
  //         ...prevState,
  //         bar1Datas: bar1,
  //         bar2Data: bar2,
  //         bar1Count: bar1Count,
  //         bar2Count: bar2Count,
  //         bar1Name: `Documents(${bar1Count})`,
  //         bar2Name: `Reviews(${bar2Count})`,
  //       }));
  //       let isBar1 = bar1.some((obj) => obj > 0);
  //       let isBar2 = bar2.some((obj) => obj > 0);
  //       if (!isBar1 && !isBar2) {
  //         // toast.warn("No records were found")
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //     setLoading(false);
  //   };

  //   const handleFetchStatus = async (year = statusChartYear) => {
  //     try {
  //       let response = await DashboardServices.getDocsStatusBarChart(
  //         userID,
  //         year,
  //       );
  //       console.log("statusdata", response);
  //       let bar1 = response.counts;
  //       console.log("bar1:", bar1);
  //       setBarDocsStatusChartData({ ...barDocsStatusChartData, counts: bar1 });
  //       console.log("bar1status2", bar1);
  //       let isBar1 = bar1.some((obj) => obj > 0);
  //       if (!isBar1) {
  //         // toast.warn("No records were found")
  //       }
  //     } catch (error) {
  //       console.log("error", error);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   handleFetchStatus();
  //   // }, []);
  //   useEffect(() => {
  //     if (!isGuest) {
  //       handleFetchStatus();
  //     }
  //   }, [isGuest]);

  //   const handleBarChartYear = (year) => {
  //     console.log("handleBarChartYear", year);
  //     let currentYear = new Date().getFullYear();
  //     if (year > currentYear) {
  //       toast.warn("Please enter current or past year");
  //       return;
  //     }
  //     getUserBarChartDetails(year);
  //   };

  //   const handleStatusChartYear = (year) => {
  //     console.log("handleStatusChartYear", year);
  //     let currentYear = new Date().getFullYear();
  //     if (year > currentYear) {
  //       toast.warn("Please enter current or past year");
  //       return;
  //     }
  //     setStatusChartYear(year);
  //     handleFetchStatus(year);
  //   };

  //   const getNotifications = async () => {
  //     try {
  //       let notifications = await getnotifications();
  //       console.log("notifications", notifications);
  //       setNotifications(notifications || []);
  //     } catch (error) {
  //       console.error("Error fetching notifications:", error);
  //       setNotifications([]);
  //     }
  //   };

  //   // useEffect(() => {
  //   //   getNotifications();
  //   // }, []);

  //   // Stats data for the cards

  //   useEffect(() => {
  //     if (!isGuest) {
  //       getNotifications();
  //     }
  //   }, [isGuest]);

  //   const statsData = [
  //     {
  //       title: "Total Documents",
  //       value: (totalMyDocs + totalSharedDocs).toString() || "0",
  //       icon: <DocumentIcon />,
  //       color: theme.palette.primary.main,
  //       link: "/mydocuments",
  //     },
  //     {
  //       title: "Pending Approval",
  //       value: imageCardData.pendingForApproval || "0",
  //       icon: <PendingIcon />,
  //       color: theme.palette.warning.main,
  //       link: "/mydocuments",
  //     },
  //     {
  //       title: "Organization Chats",
  //       value: imageCardData.unreadMsgCount || "0",
  //       icon: <ChatIcon />,
  //       color: theme.palette.success.main,
  //       link: "/chat",
  //     },
  //   ];
  //   const shouldWaitForUser = !isGuest && !userID;

  //   return shouldWaitForUser ? (
  //     <Loader loading={true} />
  //   ) : (
  //     <ThemeProvider theme={theme}>
  //       <CssBaseline />
  //       <Box
  //         sx={{
  //           flexGrow: 1,
  //           bgcolor: "background.default",
  //           minHeight: "100vh",
  //           p: { xs: 2, md: 4 },
  //           background: isDarkMode
  //             ? "radial-gradient(ellipse at top, #1a1f2e 0%, #0a0e1a 100%)"
  //             : "radial-gradient(ellipse at top, #f8fafc 0%, #e2e8f0 100%)",
  //         }}
  //       >
  //         <ToastContainer />
  //         <Loader loading={loading} />

  //         {/* Enhanced Header Section */}
  //         <Box sx={{ mb: 5 }}>
  //           <Typography
  //             variant="h4"
  //             component="h1"
  //             sx={{
  //               fontWeight: 800,
  //               color: "primary.main",
  //               mb: 1,
  //             }}
  //           >
  //             Dashboard Analytics
  //           </Typography>
  //           <Typography
  //             variant="subtitle1"
  //             color="text.primary"
  //             sx={{
  //               fontWeight: 500,
  //               opacity: 0.8,
  //             }}
  //           >
  //             Welcome back! Here's what's happening with your documents today.
  //           </Typography>
  //         </Box>

  //         {/* Stats Cards Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           {statsData.map((stat, index) => (
  //             <Grid2 item xs={12} sm={6} md={4} key={index}>
  //               <Link to={stat.link} style={{ textDecoration: "none" }}>
  //                 <StatCard
  //                   title={stat.title}
  //                   value={stat.value}
  //                   icon={stat.icon}
  //                   color={stat.color}
  //                   trend={stat.trend}
  //                   isLoading={loading}
  //                   onClick={() => {}}
  //                 />
  //               </Link>
  //             </Grid2>
  //           ))}
  //         </Grid2>

  //         {/* Enhanced Side-by-Side Charts Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           {/* Documents & Reviews Status Chart */}
  //           <Grid2 item xs={12} lg={5}>
  //             <ChartContainer
  //               title="Documents & Reviews Status"
  //               isLoading={loading}
  //               height={320}
  //               icon={<AssessmentIcon />}
  //               gradientColors={[
  //                 theme.palette.warning.main,
  //                 theme.palette.warning.light,
  //               ]}
  //               actions={
  //                 isBarChartDropdown && (
  //                   <Stack direction="row" spacing={1} alignItems="center">
  //                     <Chip
  //                       label="Status"
  //                       size="small"
  //                       sx={{
  //                         bgcolor: theme.palette.warning.light + "20",
  //                         color: theme.palette.warning.main,
  //                         fontWeight: 600,
  //                         border: `1px solid ${theme.palette.warning.main}30`,
  //                         fontSize: "0.75rem",
  //                       }}
  //                     />
  //                     <FormControl size="small" sx={{ minWidth: 100 }}>
  //                       <InputLabel>Year</InputLabel>
  //                       <Select
  //                         value={statusChartYear}
  //                         label="Year"
  //                         onChange={(e) => {
  //                           handleStatusChartYear(e.target.value);
  //                         }}
  //                         sx={{
  //                           borderRadius: 2,
  //                           fontSize: "0.875rem",
  //                           "& .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.warning.main + "30",
  //                           },
  //                           "&:hover .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.warning.main + "60",
  //                           },
  //                         }}
  //                       >
  //                         {yearList.map((year) => (
  //                           <MenuItem key={year.value} value={year.value}>
  //                             {year.name}
  //                           </MenuItem>
  //                         ))}
  //                       </Select>
  //                     </FormControl>
  //                   </Stack>
  //                 )
  //               }
  //             >
  //               <StatusApexChartsComp
  //                 chartHeading=""
  //                 cmp1={barChartData.bar1Name}
  //                 cmp2={barChartData.bar2Name}
  //                 bar1={barDocsStatusChartData.counts}
  //                 xAxisList={barDocsStatusChartData.xAxis}
  //                 isSelectDropdownShown={false}
  //                 barChartSelectOptions={yearList}
  //                 barChartValue={statusChartYear}
  //                 barChartSelectLabel="Year"
  //                 isDarkMode={isDarkMode}
  //               />
  //             </ChartContainer>
  //           </Grid2>

  //           {/* Documents & Reviews Analytics Chart */}
  //           <Grid2 item xs={12} lg={7}>
  //             <ChartContainer
  //               title="Documents & Reviews Analytics"
  //               isLoading={loading}
  //               height={320}
  //               icon={<TimelineIcon />}
  //               gradientColors={[
  //                 theme.palette.primary.main,
  //                 theme.palette.primary.light,
  //               ]}
  //               actions={
  //                 <Stack direction="row" spacing={2} alignItems="center">
  //                   <Chip
  //                     label={`Documents: ${barChartData.bar1Count}`}
  //                     size="small"
  //                     sx={{
  //                       bgcolor: theme.palette.primary.light + "20",
  //                       color: theme.palette.primary.main,
  //                       fontWeight: 600,
  //                       border: `1px solid ${theme.palette.primary.main}30`,
  //                     }}
  //                   />
  //                   <Chip
  //                     label={`Reviews: ${barChartData.bar2Count}`}
  //                     size="small"
  //                     sx={{
  //                       bgcolor: theme.palette.secondary.light + "20",
  //                       color: theme.palette.secondary.main,
  //                       fontWeight: 600,
  //                       border: `1px solid ${theme.palette.secondary.main}30`,
  //                     }}
  //                   />
  //                   {isBarChartDropdown && (
  //                     <FormControl size="small" sx={{ minWidth: 120 }}>
  //                       <InputLabel>Year</InputLabel>
  //                       <Select
  //                         value={barChartYear}
  //                         label="Year"
  //                         onChange={(e) => {
  //                           setBarChartYear(e.target.value);
  //                           handleBarChartYear(e.target.value);
  //                         }}
  //                         sx={{
  //                           borderRadius: 2,
  //                           "& .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.primary.main + "30",
  //                           },
  //                           "&:hover .MuiOutlinedInput-notchedOutline": {
  //                             borderColor: theme.palette.primary.main + "60",
  //                           },
  //                         }}
  //                       >
  //                         {yearList.map((year) => (
  //                           <MenuItem key={year.value} value={year.value}>
  //                             {year.name}
  //                           </MenuItem>
  //                         ))}
  //                       </Select>
  //                     </FormControl>
  //                   )}
  //                   <Tooltip title="Refresh Data">
  //                     <IconButton
  //                       size="small"
  //                       onClick={() => getUserBarChartDetails(barChartYear)}
  //                       sx={{
  //                         color: theme.palette.primary.main,
  //                         "&:hover": {
  //                           bgcolor: theme.palette.primary.main + "10",
  //                           transform: "rotate(180deg)",
  //                         },
  //                         transition: "all 0.3s ease",
  //                       }}
  //                     >
  //                       <RefreshIcon />
  //                     </IconButton>
  //                   </Tooltip>
  //                 </Stack>
  //               }
  //             >
  //               {/* You'll need to replace this with your actual ApexChartsComp component */}
  //               <Box
  //                 sx={{
  //                   display: "flex",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                   height: "100%",
  //                   flexDirection: "column",
  //                   gap: 2,
  //                 }}
  //               >
  //                 <BarChartIcon
  //                   sx={{
  //                     fontSize: 64,
  //                     color: theme.palette.primary.main + "40",
  //                   }}
  //                 />
  //                 <Typography variant="body1" color="text.Primary">
  //                   Chart data will be displayed here
  //                 </Typography>
  //               </Box>
  //             </ChartContainer>
  //           </Grid2>
  //         </Grid2>

  //         {/* Notifications Section */}
  //         {notifications.length > 0 && (
  //           <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //             <Grid2 item xs={12}>
  //               <Card
  //                 sx={{
  //                   background: `linear-gradient(135deg, ${theme.palette.info.light}12 0%, ${theme.palette.info.main}08 100%)`,
  //                   border: `2px solid ${theme.palette.info.light}30`,
  //                 }}
  //               >
  //                 <CardContent sx={{ p: 4 }}>
  //                   <Typography
  //                     variant="h6"
  //                     component="h2"
  //                     sx={{ fontWeight: 700, mb: 3, color: "info.main" }}
  //                   >
  //                     <NotificationIcon sx={{ mr: 2, verticalAlign: "middle" }} />
  //                     Recent Notifications
  //                   </Typography>
  //                   {/* You'll need to replace this with your actual RemainderComp component */}
  //                   <Box sx={{ p: 2 }}>
  //                     {notifications.map((notification, index) => (
  //                       <Alert
  //                         key={index}
  //                         severity="info"
  //                         sx={{ mb: 2, borderRadius: 2 }}
  //                       >
  //                         {notification.message || "New notification"}
  //                       </Alert>
  //                     ))}
  //                   </Box>
  //                 </CardContent>
  //               </Card>
  //             </Grid2>
  //           </Grid2>
  //         )}

  //         {/* Enhanced Quick Actions Section */}
  //         <Grid2 container spacing={4} sx={{ mb: 5 }}>
  //           <Grid2 item xs={12}>
  //             <Card
  //               sx={{
  //                 background: `linear-gradient(135deg, ${theme.palette.primary.light}12 0%, ${theme.palette.primary.main}08 100%)`,
  //                 border: `2px solid ${theme.palette.primary.light}30`,
  //               }}
  //             >
  //               <CardContent sx={{ p: 4 }}>
  //                 <Typography
  //                   variant="h6"
  //                   component="h2"
  //                   sx={{ fontWeight: 700, mb: 4, color: "primary.main" }}
  //                 >
  //                   <DashboardIcon sx={{ mr: 2, verticalAlign: "middle" }} />
  //                   Quick Actions
  //                 </Typography>

  //                 <Grid2 container spacing={3}>
  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<DocumentIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderWidth: 2,
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/mydocuments"
  //                     >
  //                       View All Documents
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<PendingIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "warning.main",
  //                         borderColor: "warning.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "warning.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "warning.light",
  //                           color: "warning.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/mydocuments"
  //                     >
  //                       Pending Approvals
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<ChatIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "success.main",
  //                         borderColor: "success.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "success.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "success.light",
  //                           color: "success.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                       component={Link}
  //                       to="/chat"
  //                     >
  //                       Open Chat
  //                     </Button>
  //                   </Grid2>

  //                   <Grid2 item xs={12} sm={6} md={3}>
  //                     <Button
  //                       variant="outlined"
  //                       fullWidth
  //                       startIcon={<SettingsIcon />}
  //                       sx={{
  //                         py: 2.5,
  //                         borderRadius: 3,
  //                         borderWidth: 2,
  //                         fontWeight: 600,
  //                         textTransform: "none",
  //                         fontSize: "0.95rem",
  //                         color: "secondary.main",
  //                         borderColor: "secondary.main",
  //                         "&:hover": {
  //                           transform: "translateY(-4px)",
  //                           boxShadow: theme.shadows[8],
  //                           borderColor: "secondary.main",
  //                           borderWidth: 2,
  //                           backgroundColor: "secondary.light",
  //                           color: "secondary.dark",
  //                         },
  //                         transition:
  //                           "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
  //                       }}
  //                     >
  //                       Settings
  //                     </Button>
  //                   </Grid2>
  //                 </Grid2>
  //               </CardContent>
  //             </Card>
  //           </Grid2>
  //         </Grid2>

  //         {/* Enhanced Subscription Alert Dialog */}
  //         <Dialog
  //           open={showPopup}
  //           onClose={handleClose}
  //           PaperProps={{
  //             sx: {
  //               borderRadius: 4,
  //               minWidth: { xs: "90%", sm: "500px" },
  //               background: isDarkMode
  //                 ? `linear-gradient(135deg, ${theme.palette.error.dark}15 0%, ${theme.palette.error.main}10 100%)`
  //                 : `linear-gradient(135deg, ${theme.palette.error.light}15 0%, ${theme.palette.error.main}08 100%)`,
  //               backdropFilter: "blur(20px)",
  //               border: `2px solid ${theme.palette.error.main}30`,
  //             },
  //           }}
  //         >
  //           <DialogTitle
  //             sx={{
  //               display: "flex",
  //               justifyContent: "space-between",
  //               alignItems: "center",
  //               pb: 2,
  //               borderBottom: `1px solid ${theme.palette.divider}`,
  //             }}
  //           >
  //             <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
  //               <Avatar
  //                 sx={{
  //                   bgcolor: theme.palette.error.main + "20",
  //                   color: theme.palette.error.main,
  //                   width: 48,
  //                   height: 48,
  //                 }}
  //               >
  //                 <NotificationIcon />
  //               </Avatar>
  //               <Typography
  //                 variant="h6"
  //                 sx={{ fontWeight: 700, color: "error.main" }}
  //               >
  //                 Subscription Plan Alert
  //               </Typography>
  //             </Box>
  //             <IconButton
  //               onClick={handleClose}
  //               size="small"
  //               sx={{
  //                 color: "error.main",
  //                 "&:hover": {
  //                   bgcolor: theme.palette.error.main + "10",
  //                 },
  //               }}
  //             >
  //               <CloseIcon />
  //             </IconButton>
  //           </DialogTitle>

  //           <DialogContent sx={{ pt: 3, pb: 2 }}>
  //             <Alert
  //               severity="warning"
  //               sx={{
  //                 mb: 3,
  //                 borderRadius: 3,
  //                 bgcolor: theme.palette.warning.main + "10",
  //                 border: `1px solid ${theme.palette.warning.main}30`,
  //                 "& .MuiAlert-icon": {
  //                   color: theme.palette.warning.main,
  //                 },
  //               }}
  //             >
  //               {alertForEndSub}
  //             </Alert>

  //             <Typography
  //               variant="body1"
  //               color="text.Primary"
  //               sx={{ lineHeight: 1.6 }}
  //             >
  //               Please consider renewing your subscription to continue enjoying
  //               all premium features and maintain uninterrupted access to your
  //               dashboard.
  //             </Typography>
  //           </DialogContent>

  //           <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
  //             <Button
  //               onClick={handleClose}
  //               color="primary"
  //               variant="outlined"
  //               sx={{
  //                 borderRadius: 2,
  //                 px: 3,
  //                 py: 1,
  //                 fontWeight: 600,
  //               }}
  //             >
  //               Remind Later
  //             </Button>
  //             <Button
  //               onClick={handleClose}
  //               color="error"
  //               variant="contained"
  //               sx={{
  //                 borderRadius: 2,
  //                 px: 3,
  //                 py: 1,
  //                 fontWeight: 600,
  //                 boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  //                 "&:hover": {
  //                   boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
  //                 },
  //               }}
  //             >
  //               View Plans
  //             </Button>
  //           </DialogActions>
  //         </Dialog>
  //       </Box>
  //     </ThemeProvider>
  //   );
  // };

  // export default DashboardPage;

  import React, { useState, useEffect } from "react";
  import {
    Box,
    Card,
    CardContent,
    Typography,
    Avatar,
    IconButton,
    Container,
    Skeleton,
    Chip,
    Zoom,
    useTheme,
    useMediaQuery,
    ThemeProvider,
    createTheme,
    CssBaseline,
    LinearProgress,
    Alert,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Stack,
    Tooltip,
    Button,
     styled, tooltipClasses
  } from "@mui/material";
  import {
    Dashboard as DashboardIcon,
    Description as DocumentIcon,
    PendingActions as PendingIcon,
    Chat as ChatIcon,
    Notifications as NotificationIcon,
    Settings as SettingsIcon,
    Assessment as AssessmentIcon,
    Timeline as TimelineIcon,
    BarChart as BarChartIcon,
    Refresh as RefreshIcon,
    Close as CloseIcon,
  } from "@mui/icons-material";
  import DashboardServices from "../services/dashboardServices";
  import { toast, ToastContainer } from "react-toastify";
  import Loader from "../utils/loader";
  import { useSelector } from "react-redux";
  import { Link } from "react-router-dom";
  import { getnotifications } from "../services/notficationService";
  import StatusApexChartsComp from "./ReusableComponents/StatusApexChartsComp";
  import documentService from "../services/document";
  import moment from "moment/moment";
  import Grid2 from "@mui/material/Unstable_Grid2";

    const dashboardThemeBackground = (isDarkMode) => ({
    position: 'relative',
    minHeight: '100vh',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: `
        /* Gradient overlays for depth */
        radial-gradient(circle at 5% 20%, ${isDarkMode ? 'rgba(25, 118, 210, 0.08)' : 'rgba(25, 118, 210, 0.05)'} 0%, transparent 35%),
        radial-gradient(circle at 95% 70%, ${isDarkMode ? 'rgba(156, 39, 176, 0.08)' : 'rgba(156, 39, 176, 0.05)'} 0%, transparent 40%),
        radial-gradient(circle at 30% 85%, ${isDarkMode ? 'rgba(46, 125, 50, 0.08)' : 'rgba(46, 125, 50, 0.05)'} 0%, transparent 30%),

        /* Dashboard visualization elements - charts and graphs */
        url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='400' viewBox='0 0 400 400'%3E%3C!-- Bar Chart Element --%3E%3Crect x='50' y='250' width='40' height='100' fill='%231976d2' opacity='0.05' /%3E%3Crect x='100' y='200' width='40' height='150' fill='%231976d2' opacity='0.05' /%3E%3Crect x='150' y='150' width='40' height='200' fill='%231976d2' opacity='0.05' /%3E%3Crect x='200' y='180' width='40' height='170' fill='%231976d2' opacity='0.05' /%3E%3Crect x='250' y='220' width='40' height='130' fill='%231976d2' opacity='0.05' /%3E%3C!-- Pie Chart Element --%3E%3Ccircle cx='300' cy='100' r='50' fill='none' stroke='%239c27b0' stroke-width='2' opacity='0.08' /%3E%3Cpath d='M300 100 L300 50 A50 50 0 0 1 350 100 Z' fill='%239c27b0' opacity='0.08' /%3E%3Cpath d='M300 100 L350 100 A50 50 0 0 1 300 150 Z' fill='%239c27b0' opacity='0.08' /%3E%3C!-- Line Graph Element --%3E%3Cpath d='M30 350 L80 320 L130 280 L180 250 L230 200 L280 220 L330 180' stroke='%232e7d32' stroke-width='2' fill='none' opacity='0.08' /%3E%3Ccircle cx='80' cy='320' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='130' cy='280' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='180' cy='250' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='230' cy='200' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='280' cy='220' r='3' fill='%232e7d32' opacity='0.08' /%3E%3Ccircle cx='330' cy='180' r='3' fill='%232e7d32' opacity='0.08' /%3E%3C!-- Document Icons --%3E%3Crect x='30' y='50' width='30' height='40' fill='%23ed6c02' opacity='0.05' /%3E%3Cline x1='35' y1='60' x2='55' y2='60' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3Cline x1='35' y1='70' x2='55' y2='70' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3Cline x1='35' y1='80' x2='55' y2='80' stroke='%23ed6c02' stroke-width='1' opacity='0.05' /%3E%3C!-- Stats Cards Visualization --%3E%3Crect x='120' y='30' width='60' height='50' rx='5' fill='%231976d2' opacity='0.03' /%3E%3Ccircle cx='140' cy='45' r='8' fill='%231976d2' opacity='0.08' /%3E%3Cline x1='160' y1='45' x2='170' y2='45' stroke='%231976d2' stroke-width='2' opacity='0.08' /%3E%3C/svg%3E")

        /* Subtle pattern overlay */
        ${isDarkMode ? ', repeating-linear-gradient(45deg, rgba(255,255,255,0.01) 0px, rgba(255,255,255,0.01) 2px, transparent 2px, transparent 30px)' : ', repeating-linear-gradient(45deg, rgba(0,0,0,0.01) 0px, rgba(0,0,0,0.01) 2px, transparent 2px, transparent 30px)'}
      `,
      backgroundSize: '800px 800px, 400px 400px, auto',
      backgroundRepeat: 'repeat, repeat, repeat',
      backgroundPosition: '0 0, 100px 100px, 0 0',
      backgroundAttachment: 'fixed, fixed, fixed',
      pointerEvents: 'none',
      zIndex: 0,
      animation: 'slowDrift 120s linear infinite',
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '15%',
      right: '10%',
      width: '500px',
      height: '500px',
      background: `radial-gradient(circle, ${isDarkMode ? 'rgba(156,39,176,0.03)' : 'rgba(156,39,176,0.02)'} 0%, transparent 70%)`,
      borderRadius: '50%',
      pointerEvents: 'none',
      zIndex: 0,
      animation: 'pulse 8s ease-in-out infinite',
    },
    '& > *': {
      position: 'relative',
      zIndex: 1,
    },
    '@keyframes slowDrift': {
      '0%': {
        backgroundPosition: '0 0, 100px 100px, 0 0',
      },
      '100%': {
        backgroundPosition: '500px 500px, 600px 600px, 500px 500px',
      },
    },
    '@keyframes pulse': {
      '0%, 100%': {
        opacity: 0.5,
        transform: 'scale(1)',
      },
      '50%': {
        opacity: 1,
        transform: 'scale(1.05)',
      },
    },
  });

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "blue",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    borderRadius: 8,
    padding: "6px 10px",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.white,
  },
}));

  // Enhanced Material-UI Theme
  const createCustomTheme = (isDarkMode) =>
    createTheme({
      palette: {
        mode: isDarkMode ? "dark" : "light",
        primary: {
          main: "#1976d2",
          light: "#42a5f5",
          dark: "#1565c0",
        },
        secondary: {
          main: "#9c27b0",
          light: "#ba68c8",
          dark: "#7b1fa2",
        },
        success: {
          main: "#2e7d32",
          light: "#4caf50",
          dark: "#1b5e20",
        },
        warning: {
          main: "#ed6c02",
          light: "#ff9800",
          dark: "#e65100",
        },
        error: {
          main: "#d32f2f",
          light: "#f44336",
          dark: "#c62828",
        },
        background: {
          default: isDarkMode ? "#0a0e1a" : "#f8fafc",
          paper: isDarkMode ? "#1a1f2e" : "#ffffff",
        },
        text: {
          primary: isDarkMode ? "#ffffff" : "#1a202c",
          secondary: isDarkMode ? "#a0aec0" : "#4a5568",
        },
      },
      typography: {
        fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
        h4: {
          fontWeight: 700,
          fontSize: "2.25rem",
          letterSpacing: "-0.025em",
        },
        h5: {
          fontWeight: 600,
          fontSize: "1.75rem",
          letterSpacing: "-0.025em",
        },
        h6: {
          fontWeight: 600,
          fontSize: "1.25rem",
          letterSpacing: "-0.025em",
        },
        subtitle1: {
          fontWeight: 500,
          fontSize: "1rem",
          lineHeight: 1.5,
        },
        body1: {
          fontSize: "0.875rem",
          lineHeight: 1.6,
        },
      },
      shape: {
        borderRadius: 16,
      },
      components: {
        MuiCard: {
          styleOverrides: {
            root: {
              boxShadow: isDarkMode
                ? "0 10px 40px rgba(0,0,0,0.4), 0 2px 8px rgba(0,0,0,0.2)"
                : "0 10px 40px rgba(0,0,0,0.08), 0 2px 8px rgba(0,0,0,0.04)",
              borderRadius: 20,
              transition: "all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
              border: isDarkMode
                ? "1px solid rgba(255,255,255,0.1)"
                : "1px solid rgba(0,0,0,0.05)",
              background: isDarkMode
                ? "linear-gradient(135deg, rgba(255,255,255,0.02) 0%, rgba(255,255,255,0.05) 100%)"
                : "linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(255,255,255,0.95) 100%)",
              backdropFilter: "blur(20px)",
              "&:hover": {
                transform: "translateY(-8px) scale(1.02)",
                boxShadow: isDarkMode
                  ? "0 20px 60px rgba(0,0,0,0.5), 0 8px 16px rgba(0,0,0,0.3)"
                  : "0 20px 60px rgba(0,0,0,0.12), 0 8px 16px rgba(0,0,0,0.08)",
              },
            },
          },
        },
        MuiButton: {
          styleOverrides: {
            root: {
              borderRadius: 12,
              textTransform: "none",
              fontWeight: 600,
              padding: "10px 24px",
              boxShadow: "none",
              "&:hover": {
                boxShadow: "0 8px 20px rgba(0,0,0,0.12)",
                transform: "translateY(-2px)",
              },
            },
          },
        },
        MuiPaper: {
          styleOverrides: {
            root: {
              backgroundImage: "none",
            },
          },
        },
      },
    });

  // Enhanced Stat Card Component
  const StatCard = ({ title, value, icon, color, trend, isLoading, onClick }) => {
    const theme = useTheme();

    return (
      <Zoom in={!isLoading} style={{ transitionDelay: "100ms" }}>
        <Card
          sx={{
            height: "100%",
            cursor: onClick ? "pointer" : "default",
            background: `linear-gradient(135deg, ${color}15 0%, ${color}08 50%, ${color}03 100%)`,
            border: `2px solid ${color}20`,
            position: "relative",
            overflow: "hidden",
            "&:hover": onClick
              ? {
                  transform: "translateY(-8px) scale(1.02)",
                  boxShadow: `0 20px 40px ${color}25`,
                  border: `2px solid ${color}40`,
                }
              : {},
            "&::before": {
              content: '""',
              position: "absolute",
              top: -50,
              right: -50,
              width: "150px",
              height: "150px",
              background: `radial-gradient(circle, ${color}20 0%, transparent 70%)`,
              borderRadius: "50%",
            },
            "&::after": {
              content: '""',
              position: "absolute",
              bottom: -30,
              left: -30,
              width: "100px",
              height: "100px",
              background: `linear-gradient(45deg, ${color}10, transparent)`,
              borderRadius: "50%",
            },
          }}
          onClick={onClick}
        >
          <CardContent sx={{ position: "relative", zIndex: 1, p: 3 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                mb: 3,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: `${color}25`,
                  color: color,
                  width: 64,
                  height: 64,
                  boxShadow: `0 8px 20px ${color}30`,
                }}
              >
                {icon}
              </Avatar>
              {trend && (
                <Chip
                  label={trend}
                  size="small"
                  sx={{
                    bgcolor: trend.includes("+")
                      ? theme.palette.success.main
                      : theme.palette.error.main,
                    color: "white",
                    fontWeight: 700,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  }}
                />
              )}
            </Box>

            {isLoading ? (
              <Box>
                <Skeleton variant="text" width="60%" height={36} />
                <Skeleton variant="text" width="40%" height={28} />
              </Box>
            ) : (
              <Box>
                <Typography
                  variant="h4"
                  component="div"
                  sx={{
                    fontWeight: 800,
                    color: color,
                    mb: 1,
                    textShadow: `0 2px 4px ${color}20`,
                  }}
                >
                  {value}
                </Typography>
                <Typography
                  variant="subtitle1"
                  color="text.Primary"
                  sx={{ fontWeight: 600, opacity: 0.8 }}
                >
                  {title}
                </Typography>
              </Box>
            )}
          </CardContent>
        </Card>
      </Zoom>
    );
  };

  // Enhanced Chart Container Component
  const ChartContainer = ({
    title,
    children,
    actions,
    isLoading,
    height = 400,
    icon,
    gradientColors,
  }) => {
    const theme = useTheme();

    return (
      <Card
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          background: gradientColors
            ? `linear-gradient(135deg, ${gradientColors[0]}08 0%, ${gradientColors[1]}05 50%, ${gradientColors[0]}03 100%)`
            : undefined,
          border: gradientColors ? `1px solid ${gradientColors[0]}20` : undefined,
          backdropFilter: "blur(10px)",
        }}
      >
        <CardContent
          sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 3 }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              mb: 3,
              pb: 2,
              borderBottom: `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
              {icon && (
                <Avatar
                  sx={{
                    bgcolor: gradientColors
                      ? `${gradientColors[0]}20`
                      : "primary.light",
                    color: gradientColors ? gradientColors[0] : "primary.main",
                    width: 48,
                    height: 48,
                  }}
                >
                  {icon}
                </Avatar>
              )}
              <Typography
                variant="h6"
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: gradientColors ? gradientColors[0] : "text.primary",
                  textShadow: gradientColors
                    ? `0 1px 2px ${gradientColors[0]}20`
                    : undefined,
                }}
              >
                {title}
              </Typography>
            </Box>
            {actions && (
              <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                {actions}
              </Box>
            )}
          </Box>

          {isLoading ? (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Skeleton
                variant="rectangular"
                height={height - 120}
                sx={{ borderRadius: 2 }}
              />
            </Box>
          ) : (
            <Box
              sx={{
                flexGrow: 1,
                display: "flex",
                flexDirection: "column",
                minHeight: height - 120,
              }}
            >
              {children}
            </Box>
          )}
        </CardContent>
      </Card>
    );
  };

  const DashboardPage = () => {
    const [loading, setLoading] = useState(false);
    const [selectYear, setSelectYear] = useState(new Date().getFullYear());
    const [selectMonth, setSelectMonth] = useState(new Date().getMonth() + 1);

    // FIXED: Updated years array to include current year (2026)
    const [years, setYears] = useState(() => {
      const currentYear = new Date().getFullYear();
      // Start from 2019 to current year (inclusive)
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push(year);
      }
      return yearsArray;
    });

    const [selected, setSelected] = useState(new Date().getFullYear());
    const [totalMyDocs, setTotalMyDocs] = useState(0);
    const [totalSharedDocs, setTotalSharedDocs] = useState(0);
    const [imageCardData, setImageCardData] = useState({
      totalDocuments: "0",
      pendingForApproval: "0",
      unreadMsgCount: "0",
    });
    const userDetails = useSelector((state) => state.user);
    const isGuest = localStorage.getItem("is_guest");

    const userID = userDetails?.currentUser?._id;

    const userRole = sessionStorage.getItem("Role");
    const [yearList, setYearList] = useState(() => {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push({ name: year.toString(), value: year });
      }
      return yearsArray;
    });
    const [teamList, setTeamList] = useState([]);
    const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
    const [statusChartYear, setStatusChartYear] = useState(
      new Date().getFullYear(),
    );
    const [selectedMember, setSelectedMember] = useState();
    const [isBarChartDropdown, setIsBarChartDropdown] = useState(false);
    const [isPieChartDropdown, setIsPieChartDropdown] = useState(false);
    const [barChartData, setBarChartData] = useState({
      bar1Count: 0,
      bar2Count: 0,
      chartHeading: "Documents & Reviews",
      bar1Name: `Documents(0)`,
      bar2Name: `Reviews(0)`,
      xAxis: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "June",
        "July",
        "Aug",
        "Sept",
        "Oct",
        "Nov",
        "Dec",
      ],
      bar1Datas: [],
      bar2Data: [],
    });
    const [barDocsStatusChartData, setBarDocsStatusChartData] = useState({
      chartHeading: "Documents & Reviews Status",
      bar1Name: "Documents",
      bar2Name: "Reviews",
      xAxis: ["Pending", "Progress", "Completed", "Rejected", "Published"],
      counts: [],
    });
    const [notifications, setNotifications] = useState([]);
    const [isDarkMode, setIsDarkMode] = useState(false);
    const screenData = useSelector(
      (state) => state.manageSubscriptionPlan.subscriptionPlan,
    );
    const [alertForEndSub, setAlertForEndSub] = useState("");
    const [showPopup, setShowPopup] = useState(false);

    const theme = createCustomTheme(isDarkMode);
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isTablet = useMediaQuery(theme.breakpoints.down("lg"));

    // ✅ Guest demo data
    useEffect(() => {
      if (isGuest) {
        setTotalMyDocs(12);
        setTotalSharedDocs(4);

        setImageCardData({
          totalDocuments: "16",
          pendingForApproval: "3",
          unreadMsgCount: "5",
        });

        setBarChartData((prev) => ({
          ...prev,
          bar1Datas: [2, 3, 4, 5, 6, 4, 3, 2, 1, 3, 5, 4],
          bar2Data: [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 3, 2],
          bar1Count: 42,
          bar2Count: 22,
          bar1Name: "Documents(42)",
          bar2Name: "Reviews(22)",
        }));

        setBarDocsStatusChartData((prev) => ({
          ...prev,
          counts: [3, 5, 8, 2, 6],
        }));
      }
    }, [isGuest]);

    useEffect(() => {
      const alertShown = sessionStorage.getItem("subscriptionAlertShown");
      const roleOfUser = sessionStorage.getItem("Role");

      const checkSubscriptionExpiry = () => {
        if (
          !alertShown &&
          screenData?.isDefault == false &&
          roleOfUser == "Individual"
        ) {
          const now = moment().startOf("day");
          const expiryDate = moment(screenData?.endDate).startOf("day");
          const daysLeft = expiryDate.diff(now, "days");

          if (daysLeft >= 1 && daysLeft <= 5) {
            setAlertForEndSub(
              `Your subscription will expire in ${daysLeft} day(s) on ${expiryDate.format(
                "D MMMM YYYY",
              )}.`,
            );
            setShowPopup(true);
          } else if (daysLeft === 0) {
            setAlertForEndSub(
              `Your subscription expires today on ${expiryDate.format(
                "D MMMM YYYY",
              )}.`,
            );
            setShowPopup(true);
          } else {
            setAlertForEndSub("");
          }
          if ((daysLeft >= 1 && daysLeft <= 5) || daysLeft === 0) {
            sessionStorage.setItem("subscriptionAlertShown", "true");
          }
        }
      };

      checkSubscriptionExpiry();
    }, [screenData?.endDate]);

    const handleClose = () => {
      setShowPopup(false);
    };

    useEffect(() => {
      const updateTheme = () => {
        const theme = localStorage.getItem("ThemeSwitch");
        setIsDarkMode(theme === "true");
      };
      updateTheme();
      window.addEventListener("storage", updateTheme);
      const originalSetItem = localStorage.setItem;
      localStorage.setItem = function (key, value) {
        originalSetItem.apply(this, arguments);
        if (key === "ThemeSwitch") {
          updateTheme();
        }
      };
      return () => {
        window.removeEventListener("storage", updateTheme);
        localStorage.setItem = originalSetItem;
      };
    }, []);

    const { leftNavbarOpen } = useSelector(
      (state) => state.handleModelAndSideBavBar,
    );

    // Initialize year list dynamically
    useEffect(() => {
      const currentYear = new Date().getFullYear();
      const yearsArray = [];
      for (let year = 2019; year <= currentYear; year++) {
        yearsArray.push({ name: year.toString(), value: year });
      }
      setYearList(yearsArray);
      setYears(yearsArray.map((y) => y.value));
      setIsBarChartDropdown(true);
    }, []);

    useEffect(() => {
      if (!isGuest) {
        fetchYearList();
        getUserDashCardDetails();
        getUserBarChartDetails(barChartYear);
      }
    }, [isGuest]);

    const fetchYearList = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getYearList();
        console.log("fetchYearList", response);
        if (response.status == 200) {
          // Ensure current year is included
          const currentYear = new Date().getFullYear();
          const serverYears = response.yearList || [];

          // Check if current year is in the list
          if (!serverYears.includes(currentYear)) {
            serverYears.push(currentYear);
            serverYears.sort((a, b) => a - b);
          }

          let finalArr = serverYears.map((year) => ({
            name: year.toString(),
            value: year,
          }));
          setYearList(finalArr);
          setYears(serverYears);
          setIsBarChartDropdown(true);
        }
      } catch (error) {
        console.log("error", error);
        // Fallback: create years array manually
        const currentYear = new Date().getFullYear();
        const yearsArray = [];
        for (let year = 2019; year <= currentYear; year++) {
          yearsArray.push(year);
        }
        const finalArr = yearsArray.map((year) => ({
          name: year.toString(),
          value: year,
        }));
        setYearList(finalArr);
        setYears(yearsArray);
        setIsBarChartDropdown(true);
      }
      setLoading(false);
    };

    const fetchTeamList = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getTeamMembersDetails(userID);
        console.log("fetchTeamList", response);
        let finalArr = [];
        response.memberNames.map((obj) =>
          finalArr.push({ name: obj.name, value: obj.id }),
        );
        setTeamList(finalArr);
        setIsPieChartDropdown(true);
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const getDocs = async () => {
      try {
        const response = await documentService.getAllMyDocuments();
        if (response.status === 200) {
          setTotalMyDocs(response.data.length);
        } else {
          console.error("Error fetching data:", response.message);
        }
      } catch (error) {
        console.error("Error calling backend API:", error.message);
      }
    };

    const getSharedDocs = async () => {
      try {
        const response = await documentService.getSharedDocuments();
        if (response.status === 200) {
          setTotalSharedDocs(response.data.length);
        } else {
          console.error("Error fetching data:", response.message);
        }
      } catch (error) {
        console.error("Error calling backend API:", error.message);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        getDocs();
        getSharedDocs();
      }
    }, [isGuest]);

    const getUserDashCardDetails = async () => {
      setLoading(true);
      try {
        let response = await DashboardServices.getIndividualDashCards(userID);
        console.log("getUserDashCardDetails", response);
        let { totalDocuments, pendingForApproval, unreadMsgCount } = response;
        setImageCardData({
          totalDocuments: totalDocuments,
          pendingForApproval: pendingForApproval,
          unreadMsgCount: unreadMsgCount,
        });
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const getUserBarChartDetails = async (year) => {
      setLoading(true);
      try {
        let response = await DashboardServices.getIndividualBarChart(
          userID,
          year,
        );
        console.log("getUserBarChartDetails", response);
        let { bar1, bar2, bar1Count, bar2Count } = response;
        setBarChartData((prevState) => ({
          ...prevState,
          bar1Datas: bar1,
          bar2Data: bar2,
          bar1Count: bar1Count,
          bar2Count: bar2Count,
          bar1Name: `Documents(${bar1Count})`,
          bar2Name: `Reviews(${bar2Count})`,
        }));
        let isBar1 = bar1.some((obj) => obj > 0);
        let isBar2 = bar2.some((obj) => obj > 0);
        if (!isBar1 && !isBar2) {
          // toast.warn("No records were found")
        }
      } catch (error) {
        console.log("error", error);
      }
      setLoading(false);
    };

    const handleFetchStatus = async (year = statusChartYear) => {
      try {
        let response = await DashboardServices.getDocsStatusBarChart(
          userID,
          year,
        );
        console.log("statusdata", response);
        let bar1 = response.counts;
        console.log("bar1:", bar1);
        setBarDocsStatusChartData({ ...barDocsStatusChartData, counts: bar1 });
        console.log("bar1status2", bar1);
        let isBar1 = bar1.some((obj) => obj > 0);
        if (!isBar1) {
          // toast.warn("No records were found")
        }
      } catch (error) {
        console.log("error", error);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        handleFetchStatus();
      }
    }, [isGuest]);

    const handleBarChartYear = (year) => {
      console.log("handleBarChartYear", year);
      let currentYear = new Date().getFullYear();
      if (year > currentYear) {
        toast.warn("Please enter current or past year");
        return;
      }
      getUserBarChartDetails(year);
    };

    const handleStatusChartYear = (year) => {
      console.log("handleStatusChartYear", year);
      let currentYear = new Date().getFullYear();
      if (year > currentYear) {
        toast.warn("Please enter current or past year");
        return;
      }
      setStatusChartYear(year);
      handleFetchStatus(year);
    };

    const getNotifications = async () => {
      try {
        let notifications = await getnotifications();
        console.log("notifications", notifications);
        setNotifications(notifications || []);
      } catch (error) {
        console.error("Error fetching notifications:", error);
        setNotifications([]);
      }
    };

    useEffect(() => {
      if (!isGuest) {
        getNotifications();
      }
    }, [isGuest]);

    const statsData = [
      {
        title: "Total Documents",
        value: (totalMyDocs + totalSharedDocs).toString() || "0",
        icon: <DocumentIcon />,
        color: theme.palette.primary.main,
        link: "/mydocuments",
      },
      {
        title: "Pending Approval",
        value: imageCardData.pendingForApproval || "0",
        icon: <PendingIcon />,
        color: theme.palette.warning.main,
        link: "/mydocuments",
      },
      {
        title: "Workspace Chats",
        value: imageCardData.unreadMsgCount || "0",
        icon: <ChatIcon />,
        color: theme.palette.success.main,
        link: "/chat",
      },
    ];
    const shouldWaitForUser = !isGuest && !userID;

    return shouldWaitForUser ? (
      <Loader loading={true} />
    ) : (
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Box
          sx={{
            flexGrow: 1,
            minHeight: "100vh",
            p: { xs: 2, md: 4 },
            // Apply the enhanced dashboard theme background
            ...dashboardThemeBackground(isDarkMode),
            // Keep your existing background as fallback
            background: isDarkMode
              ? "radial-gradient(ellipse at top, #1a1f2e 0%, #0a0e1a 100%)"
              : "radial-gradient(ellipse at top, #f8fafc 0%, #e2e8f0 100%)",
          }}
        >
          <ToastContainer />
          <Loader loading={loading} />

          {/* Enhanced Header Section */}
          <Box sx={{ mb: 5 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 800,
                color: "primary.main",
                mb: 1,
              }}
            >
              Dashboard Analytics
            </Typography>
            <Typography
              variant="subtitle1"
              color="text.primary"
              sx={{
                fontWeight: 500,
                opacity: 0.8,
              }}
            >
              Welcome back! Here's what's happening with your documents today.
            </Typography>
          </Box>

          {/* Stats Cards Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            {statsData.map((stat, index) => (
              <Grid2 item xs={12} sm={6} md={4} key={index}>
                <Link to={stat.link} style={{ textDecoration: "none" }}>
                  <StatCard
                    title={stat.title}
                    value={stat.value}
                    icon={stat.icon}
                    color={stat.color}
                    trend={stat.trend}
                    isLoading={loading}
                    onClick={() => {}}
                  />
                </Link>
              </Grid2>
            ))}
          </Grid2>

          {/* Enhanced Side-by-Side Charts Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            {/* Documents & Reviews Status Chart */}
            <Grid2 item xs={12} lg={5}>
              <ChartContainer
                title="Documents & Reviews Status"
                isLoading={loading}
                height={320}
                icon={<AssessmentIcon />}
                gradientColors={[
                  theme.palette.warning.main,
                  theme.palette.warning.light,
                ]}
                actions={
                  isBarChartDropdown && (
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip
                        label="Status"
                        size="small"
                        sx={{
                          bgcolor: theme.palette.warning.light + "20",
                          color: theme.palette.warning.main,
                          fontWeight: 600,
                          border: `1px solid ${theme.palette.warning.main}30`,
                          fontSize: "0.75rem",
                        }}
                      />
                      <FormControl size="small" sx={{ minWidth: 100 }}>
                        <InputLabel>Year</InputLabel>
                        <Select
                          value={statusChartYear}
                          label="Year"
                          onChange={(e) => {
                            handleStatusChartYear(e.target.value);
                          }}
                          sx={{
                            borderRadius: 2,
                            fontSize: "0.875rem",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.warning.main + "30",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.warning.main + "60",
                            },
                          }}
                        >
                          {yearList.map((year) => (
                            <MenuItem key={year.value} value={year.value}>
                              {year.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Stack>
                  )
                }
              >
                <StatusApexChartsComp
                  chartHeading=""
                  cmp1={barChartData.bar1Name}
                  cmp2={barChartData.bar2Name}
                  bar1={barDocsStatusChartData.counts}
                  xAxisList={barDocsStatusChartData.xAxis}
                  isSelectDropdownShown={false}
                  barChartSelectOptions={yearList}
                  barChartValue={statusChartYear}
                  barChartSelectLabel="Year"
                  isDarkMode={isDarkMode}
                />
              </ChartContainer>
            </Grid2>

            {/* Documents & Reviews Analytics Chart */}
            <Grid2 item xs={12} lg={7}>
              <ChartContainer
                title="Documents & Reviews Analytics"
                isLoading={loading}
                height={320}
                icon={<TimelineIcon />}
                gradientColors={[
                  theme.palette.primary.main,
                  theme.palette.primary.light,
                ]}
                actions={
                  <Stack direction="row" spacing={2} alignItems="center">
                    <Chip
                      label={`Documents: ${barChartData.bar1Count}`}
                      size="small"
                      sx={{
                        bgcolor: theme.palette.primary.light + "20",
                        color: theme.palette.primary.main,
                        fontWeight: 600,
                        border: `1px solid ${theme.palette.primary.main}30`,
                      }}
                    />
                    <Chip
                      label={`Reviews: ${barChartData.bar2Count}`}
                      size="small"
                      sx={{
                        bgcolor: theme.palette.secondary.light + "20",
                        color: theme.palette.secondary.main,
                        fontWeight: 600,
                        border: `1px solid ${theme.palette.secondary.main}30`,
                      }}
                    />
                    {isBarChartDropdown && (
                      <FormControl size="small" sx={{ minWidth: 120 }}>
                        <InputLabel>Year</InputLabel>
                        <Select
                          value={barChartYear}
                          label="Year"
                          onChange={(e) => {
                            setBarChartYear(e.target.value);
                            handleBarChartYear(e.target.value);
                          }}
                          sx={{
                            borderRadius: 2,
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.primary.main + "30",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: theme.palette.primary.main + "60",
                            },
                          }}
                        >
                          {yearList.map((year) => (
                            <MenuItem key={year.value} value={year.value}>
                              {year.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                    <LightTooltip  title="Refresh Data">
                      <IconButton
                        size="small"
                        onClick={() => getUserBarChartDetails(barChartYear)}
                        sx={{
                          color: theme.palette.primary.main,
                          "&:hover": {
                            bgcolor: theme.palette.primary.main + "10",
                            transform: "rotate(180deg)",
                          },
                          transition: "all 0.3s ease",
                        }}
                      >
                        <RefreshIcon />
                      </IconButton>
                    </LightTooltip>
                  </Stack>
                }
              >
                {/* You'll need to replace this with your actual ApexChartsComp component */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    flexDirection: "column",
                    gap: 2,
                  }}
                >
                  <BarChartIcon
                    sx={{
                      fontSize: 64,
                      color: theme.palette.primary.main + "40",
                    }}
                  />
                  <Typography variant="body1" color="text.Primary">
                    Chart data will be displayed here
                  </Typography>
                </Box>
              </ChartContainer>
            </Grid2>
          </Grid2>

          {/* Notifications Section */}
          {notifications.length > 0 && (
            <Grid2 container spacing={4} sx={{ mb: 5 }}>
              <Grid2 item xs={12}>
                <Card
                  sx={{
                    background: `linear-gradient(135deg, ${theme.palette.info.light}12 0%, ${theme.palette.info.main}08 100%)`,
                    border: `2px solid ${theme.palette.info.light}30`,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <CardContent sx={{ p: 4 }}>
                    <Typography
                      variant="h6"
                      component="h2"
                      sx={{ fontWeight: 700, mb: 3, color: "info.main" }}
                    >
                      <NotificationIcon sx={{ mr: 2, verticalAlign: "middle" }} />
                      Recent Notifications
                    </Typography>
                    {/* You'll need to replace this with your actual RemainderComp component */}
                    <Box sx={{ p: 2 }}>
                      {notifications.map((notification, index) => (
                        <Alert
                          key={index}
                          severity="info"
                          sx={{ mb: 2, borderRadius: 2 }}
                        >
                          {notification.message || "New notification"}
                        </Alert>
                      ))}
                    </Box>
                  </CardContent>
                </Card>
              </Grid2>
            </Grid2>
          )}

          {/* Enhanced Quick Actions Section */}
          <Grid2 container spacing={4} sx={{ mb: 5 }}>
            <Grid2 item xs={12}>
              <Card
                sx={{
                  background: `linear-gradient(135deg, ${theme.palette.primary.light}12 0%, ${theme.palette.primary.main}08 100%)`,
                  border: `2px solid ${theme.palette.primary.light}30`,
                  backdropFilter: "blur(10px)",
                }}
              >
                <CardContent sx={{ p: 4 }}>
                  <Typography
                    variant="h6"
                    component="h2"
                    sx={{ fontWeight: 700, mb: 4, color: "primary.main" }}
                  >
                    <DashboardIcon sx={{ mr: 2, verticalAlign: "middle" }} />
                    Quick Actions
                  </Typography>

                  <Grid2 container spacing={3}>
                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<DocumentIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderWidth: 2,
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/mydocuments"
                      >
                        View All Documents
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<PendingIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "warning.main",
                          borderColor: "warning.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "warning.main",
                            borderWidth: 2,
                            backgroundColor: "warning.light",
                            color: "warning.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/mydocuments"
                      >
                        Pending Approvals
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<ChatIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "success.main",
                          borderColor: "success.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "success.main",
                            borderWidth: 2,
                            backgroundColor: "success.light",
                            color: "success.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/chat"
                      >
                        Open Chat
                      </Button>
                    </Grid2>

                    <Grid2 item xs={12} sm={6} md={3}>
                      <Button
                        variant="outlined"
                        fullWidth
                        startIcon={<SettingsIcon />}
                        sx={{
                          py: 2.5,
                          borderRadius: 3,
                          borderWidth: 2,
                          fontWeight: 600,
                          textTransform: "none",
                          fontSize: "0.95rem",
                          color: "secondary.main",
                          borderColor: "secondary.main",
                          "&:hover": {
                            transform: "translateY(-4px)",
                            boxShadow: theme.shadows[8],
                            borderColor: "secondary.main",
                            borderWidth: 2,
                            backgroundColor: "secondary.light",
                            color: "secondary.dark",
                          },
                          transition:
                            "all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)",
                        }}
                        component={Link}
                        to="/accountsettings"
                      >
                        Settings
                      </Button>
                    </Grid2>
                  </Grid2>
                </CardContent>
              </Card>
            </Grid2>
          </Grid2>

          {/* Enhanced Subscription Alert Dialog */}
          <Dialog
            open={showPopup}
            onClose={handleClose}
            PaperProps={{
              sx: {
                borderRadius: 4,
                minWidth: { xs: "90%", sm: "500px" },
                background: isDarkMode
                  ? `linear-gradient(135deg, ${theme.palette.error.dark}15 0%, ${theme.palette.error.main}10 100%)`
                  : `linear-gradient(135deg, ${theme.palette.error.light}15 0%, ${theme.palette.error.main}08 100%)`,
                backdropFilter: "blur(20px)",
                border: `2px solid ${theme.palette.error.main}30`,
              },
            }}
          >
            <DialogTitle
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                pb: 2,
                borderBottom: `1px solid ${theme.palette.divider}`,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Avatar
                  sx={{
                    bgcolor: theme.palette.error.main + "20",
                    color: theme.palette.error.main,
                    width: 48,
                    height: 48,
                  }}
                >
                  <NotificationIcon />
                </Avatar>
                <Typography
                  variant="h6"
                  sx={{ fontWeight: 700, color: "error.main" }}
                >
                  Subscription Plan Alert
                </Typography>
              </Box>
              <IconButton
                onClick={handleClose}
                size="small"
                sx={{
                  color: "error.main",
                  "&:hover": {
                    bgcolor: theme.palette.error.main + "10",
                  },
                }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>

            <DialogContent sx={{ pt: 3, pb: 2 }}>
              <Alert
                severity="warning"
                sx={{
                  mb: 3,
                  borderRadius: 3,
                  bgcolor: theme.palette.warning.main + "10",
                  border: `1px solid ${theme.palette.warning.main}30`,
                  "& .MuiAlert-icon": {
                    color: theme.palette.warning.main,
                  },
                }}
              >
                {alertForEndSub}
              </Alert>

              <Typography
                variant="body1"
                color="text.Primary"
                sx={{ lineHeight: 1.6 }}
              >
                Please consider renewing your subscription to continue enjoying
                all premium features and maintain uninterrupted access to your
                dashboard.
              </Typography>
            </DialogContent>

            <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
              <Button
                onClick={handleClose}
                color="primary"
                variant="outlined"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                }}
              >
                Remind Later
              </Button>
              <Button
                onClick={handleClose}
                color="error"
                variant="contained"
                sx={{
                  borderRadius: 2,
                  px: 3,
                  py: 1,
                  fontWeight: 600,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                  },
                }}
              >
                View Plans
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </ThemeProvider>
    );
  };

  export default DashboardPage;



// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Avatar,
//   IconButton,
//   Skeleton,
//   Chip,
//   Zoom,
//   useMediaQuery,
//   ThemeProvider,
//   createTheme,
//    Alert,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Select,
//   MenuItem,
//   FormControl,
//   InputLabel,
//   Stack,
//   Tooltip,
//   Button,
//   styled,
//   tooltipClasses,
 
// } from "@mui/material";
// import {
//   Dashboard as DashboardIcon,
//   Description as DocumentIcon,
//   PendingActions as PendingIcon,
//   Chat as ChatIcon,
//   Notifications as NotifIcon,
//   Settings as SettingsIcon,
//   Assessment as AssessmentIcon,
//   Timeline as TimelineIcon,
//   BarChart as BarChartIcon,
//   Refresh as RefreshIcon,
//   Close as CloseIcon,
// } from "@mui/icons-material";
// import DashboardServices from "../services/dashboardServices";
// import { toast, ToastContainer } from "react-toastify";
// import Loader from "../utils/loader";
// import { useSelector } from "react-redux";
// import { Link } from "react-router-dom";
// import { getnotifications } from "../services/notficationService";
// import StatusApexChartsComp from "./ReusableComponents/StatusApexChartsComp";
// import documentService from "../services/document";
// import moment from "moment/moment";
// import Grid from "@mui/material/Unstable_Grid2";

// const GALAXY_BG = `  
// radial-gradient(circle at 20% 30%, rgba(255,255,255,0.35), transparent 40%),
// radial-gradient(circle at 80% 70%, rgba(170,150,255,0.25), transparent 45%),
// linear-gradient(
// 165deg,
// #1a0b5e 0%,
// #2436a8 12%,
// #7b6cf6 22%,
// #b7b0f5 32%,
// #e9e6fb 42%,
// #f5f3ff 50%,
// #e2d7ff 58%,
// #c0a9ff 68%,
// #9b7df2 78%,
// #4a2bbf 88%,
// #1a0b5e 100%
// );
//   // linear-gradient(165deg,
//   //   #0e0157 0%,   #0b1f75 10%,  #876bf5 20%,
//   //   #ada6ee 30%,  #e3dcf5 40%,  #ebe3fa 48%,
//   //   #c2a6fd 56%,  #dbd9e3 64%,  #b39ef3 73%,
//   //   #6b2dd4 82%,  #0b1f75 90%,  #0e0157 100%
//   // )

// //   linear-gradient(135deg,
// //   #4f23ee 0%,
// //   #664bd2 15%,
// //   #bba6ef 30%,
// //   #c4b7f1 45%,
// //   #b1a4e4 60%,
// //   #c0b2f9 75%,
// //   #b2a3f1 100%
// // )
// `;

// const STARS = Array.from({ length: 90 }, (_, i) => ({
//   x: ((i * 2539 + 419) % 10000) / 100,
//   y: ((i * 1733 + 137) % 10000) / 100,
//   sz: i % 11 === 0 ? 3.4 : i % 5 === 0 ? 2.2 : i % 3 === 0 ? 1.6 : 1.0,
//   dl: ((i * 0.31) % 5.5).toFixed(2),
//   dr: (1.6 + (i % 8) * 0.45).toFixed(1),
//   bright: i % 6 === 0,
// }));

// const CARD_PALETTES = [
//   {
//     bg: "linear-gradient(145deg, rgba(188,215,255,0.58) 0%, rgba(205,225,255,0.42) 50%, rgba(222,238,255,0.24) 100%)",
//     border: "rgba(188,215,255,0.72)",
//     shimmer: "rgba(188,215,255,0.75)",
//     iconBg: "rgba(72,128,228,0.24)",
//     iconBd: "rgba(188,215,255,0.72)",
//     iconCol: "#2040a8",
//     numCol: "#1530a0",
//     lblCol: "rgba(15,30,120,0.88)",
//     glow: "rgba(120,175,255,0.38)",
//     sparkles: [
//       "radial-gradient(1.8px 1.8px at 10% 15%,rgba(255,255,255,0.95) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 82% 12%,rgba(255,255,255,0.90) 0%,transparent 100%)",
//       "radial-gradient(2.2px 2.2px at 88% 78%,rgba(255,255,255,0.75) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 22% 88%,rgba(255,255,255,0.92) 0%,transparent 100%)",
//       "radial-gradient(1.6px 1.6px at 62% 38%,rgba(255,255,255,0.72) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 46% 65%,rgba(255,255,255,0.84) 0%,transparent 100%)",
//       "radial-gradient(1.0px 1.0px at 74% 55%,rgba(255,255,255,0.68) 0%,transparent 100%)",
//       "radial-gradient(0.9px 0.9px at 38% 30%,rgba(255,255,255,0.80) 0%,transparent 100%)",
//     ],
//   },
//   {
//     bg: "linear-gradient(145deg, rgba(255,175,148,0.58) 0%, rgba(255,196,172,0.42) 50%, rgba(255,216,200,0.24) 100%)",
//     border: "rgba(255,185,158,0.72)",
//     shimmer: "rgba(255,185,158,0.75)",
//     iconBg: "rgba(218,82,45,0.24)",
//     iconBd: "rgba(255,175,148,0.72)",
//     iconCol: "#a02810",
//     numCol: "#8e2005",
//     lblCol: "rgba(108,28,5,0.88)",
//     glow: "rgba(255,152,110,0.38)",
//     sparkles: [
//       "radial-gradient(1.8px 1.8px at 10% 15%,rgba(255,255,255,0.95) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 82% 12%,rgba(255,255,255,0.90) 0%,transparent 100%)",
//       "radial-gradient(2.2px 2.2px at 88% 78%,rgba(255,255,255,0.75) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 22% 88%,rgba(255,255,255,0.92) 0%,transparent 100%)",
//       "radial-gradient(1.6px 1.6px at 62% 38%,rgba(255,255,255,0.72) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 46% 65%,rgba(255,255,255,0.84) 0%,transparent 100%)",
//       "radial-gradient(1.0px 1.0px at 74% 55%,rgba(255,255,255,0.68) 0%,transparent 100%)",
//       "radial-gradient(0.9px 0.9px at 38% 30%,rgba(255,255,255,0.80) 0%,transparent 100%)",
//     ],
//   },
//   {
//     bg: "linear-gradient(145deg, rgba(140,230,210,0.54) 0%, rgba(165,240,224,0.38) 50%, rgba(195,248,238,0.20) 100%)",
//     border: "rgba(148,234,214,0.72)",
//     shimmer: "rgba(148,234,214,0.75)",
//     iconBg: "rgba(15,152,122,0.24)",
//     iconBd: "rgba(140,230,210,0.72)",
//     iconCol: "#077258",
//     numCol: "#045645",
//     lblCol: "rgba(4,70,52,0.88)",
//     glow: "rgba(95,215,188,0.38)",
//     sparkles: [
//       "radial-gradient(1.8px 1.8px at 10% 15%,rgba(255,255,255,0.95) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 82% 12%,rgba(255,255,255,0.90) 0%,transparent 100%)",
//       "radial-gradient(2.2px 2.2px at 88% 78%,rgba(255,255,255,0.75) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 22% 88%,rgba(255,255,255,0.92) 0%,transparent 100%)",
//       "radial-gradient(1.6px 1.6px at 62% 38%,rgba(255,255,255,0.72) 0%,transparent 100%)",
//       "radial-gradient(1.2px 1.2px at 46% 65%,rgba(255,255,255,0.84) 0%,transparent 100%)",
//       "radial-gradient(1.0px 1.0px at 74% 55%,rgba(255,255,255,0.68) 0%,transparent 100%)",
//       "radial-gradient(0.9px 0.9px at 38% 30%,rgba(255,255,255,0.80) 0%,transparent 100%)",
//     ],
//   },
// ];

// // const DashGlobals = () => (
// //   <GlobalStyles
// //     styles={`
// //       @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700;800&display=swap');
// //       @keyframes gxTwinkle {
// //         0%,100% { opacity:0.12; transform:scale(0.55); }
// //         50%      { opacity:1.00; transform:scale(1.55); }
// //       }
// //       @keyframes gxArm1 {
// //         0%  { opacity:0.58; transform:rotate(-18deg) translate(0px,0px) scale(1.00); }
// //         50% { opacity:0.88; transform:rotate(-14deg) translate(18px,-12px) scale(1.02); }
// //         100%{ opacity:0.58; transform:rotate(-18deg) translate(0px,0px) scale(1.00); }
// //       }
// //       @keyframes gxArm2 {
// //         0%  { opacity:0.48; transform:rotate(12deg) translate(0px,0px) scale(1.00); }
// //         50% { opacity:0.75; transform:rotate(15deg) translate(-14px,14px) scale(1.02); }
// //         100%{ opacity:0.48; transform:rotate(12deg) translate(0px,0px) scale(1.00); }
// //       }
// //       @keyframes gxCore {
// //         0%,100% { opacity:0.88; transform:scale(1.00); }
// //         50%      { opacity:1.00; transform:scale(1.07); }
// //       }
// //       @keyframes gxBreath {
// //         0%,100% { opacity:0.42; transform:scale(1.00); }
// //         50%      { opacity:0.65; transform:scale(1.05); }
// //       }
// //       @keyframes gxFloat {
// //         from { opacity:0; transform:translateY(20px) scale(0.97); }
// //         to   { opacity:1; transform:translateY(0px) scale(1.00); }
// //       }
// //     `}
// //   />
// // );

// const theme = createTheme({
//   palette: {
//     mode: "dark",
//     primary: { main: "#8848d8", light: "#c090ff", dark: "#5820a8" },
//     secondary: { main: "#d858e8", light: "#ee98ff", dark: "#a020b8" },
//     success: { main: "#25b085", light: "#50c8a5", dark: "#108060" },
//     warning: { main: "#e87025", light: "#f5a050", dark: "#c05508" },
//     error: { main: "#e85050", light: "#f58080", dark: "#c02020" },
//     info: { main: "#2a7af4", light: "#80b0ff", dark: "#2060c8" },
//     background: { default: "#f3f0ff", paper: "rgba(255,255,255,0.75)" },
//     text: { primary: "#ffffff", secondary: "rgba(255,250,255,0.80)" },
//     divider: "rgba(255,255,255,0.20)",
//   },
//   typography: {
//     fontFamily: '"Outfit","Segoe UI",sans-serif',
//     h4: { fontWeight: 800, letterSpacing: "-0.02em" },
//     h6: { fontWeight: 700 },
//     body1: { fontSize: "0.875rem" },
//   },
//   shape: { borderRadius: 16 },
//   components: {
//     MuiCard: {
//       styleOverrides: {
//         root: {
//           backdropFilter: "blur(30px) saturate(170%)",
//           WebkitBackdropFilter: "blur(30px) saturate(170%)",
//           border: "1px solid rgba(255,255,255,0.28)",
//           borderRadius: 20,
//           transition: "all 0.4s cubic-bezier(0.175,0.885,0.32,1.275)",
//           backgroundImage: "none",
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 50,
//           textTransform: "none",
//           fontWeight: 600,
//           fontSize: "0.88rem",
//           backdropFilter: "blur(14px)",
//           transition: "all 0.28s ease",
//           "&:hover": { transform: "translateY(-2px)" },
//         },
//         outlined: { borderWidth: "1.5px", "&:hover": { borderWidth: "1.5px" } },
//       },
//     },
//     MuiPaper: { styleOverrides: { root: { backgroundImage: "none" } } },
//   },
// });

// const GalaxyTip = styled(({ className, ...p }) => (
//   <Tooltip {...p} classes={{ popper: className }} />
// ))(() => ({
//   [`& .${tooltipClasses.tooltip}`]: {
//     background: "rgba(42,12,108,0.94)",
//     color: "#eedeff",
//     backdropFilter: "blur(14px)",
//     border: "1px solid rgba(210,175,255,0.28)",
//     fontSize: 12,
//     borderRadius: 8,
//     padding: "5px 12px",
//     boxShadow: "0 4px 22px rgba(0,0,0,0.28)",
//   },
//   [`& .${tooltipClasses.arrow}`]: { color: "rgba(42,12,108,0.94)" },
// }));

// const YearSelect = ({ value, onChange, yearList, accent = "#c090ff" }) => (
//   <FormControl size="small" sx={{ minWidth: 95 }}>
//     <InputLabel
//       sx={{
//         color: "rgba(1, 2, 7, 0.68)",
//         fontSize: "0.74rem",
//         "&.Mui-focused": { color: accent },
//       }}
//     >
//       Year
//     </InputLabel>
//     <Select
//       value={value}
//       label="Year"
//       onChange={onChange}
//       sx={{
//         background: "rgba(252, 252, 252, 0.9)",
//         backdropFilter: "blur(14px)",
//         borderRadius: 2,
//         fontSize: "0.84rem",
//         color: "#8d13ff",
//         "& .MuiOutlinedInput-notchedOutline": {
//           borderColor: "rgba(161, 53, 249, 0.76)",
//         },
//         "&:hover .MuiOutlinedInput-notchedOutline": {
//           borderColor: "rgba(217, 14, 14, 0.46)",
//         },
//         "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
//           borderColor: accent,
//         },
//         "& .MuiSvgIcon-root": { color: "rgba(113, 31, 245, 0.72)" },
//       }}
//       MenuProps={{
//         PaperProps: {
//           sx: {
//             background: "rgba(125, 69, 245, 0.97)",
//             backdropFilter: "blur(24px)",
//             border: "1px solid rgba(153, 83, 244, 0.22)",
//             borderRadius: 2,
//             boxShadow: "0 20px 60px rgba(0,0,0,0.42)",
//             "& .MuiMenuItem-root": {
//               color: "#6634c2",
//               fontSize: "0.84rem",
//               "&:hover": { background: "rgba(255,255,255,0.12)" },
//               "&.Mui-selected": { background: "rgba(255,255,255,0.20)" },
//             },
//           },
//         },
//       }}
//     >
//       {yearList.map((y) => (
//         <MenuItem key={y.value} value={y.value}>
//           {y.name}
//         </MenuItem>
//       ))}
//     </Select>
//   </FormControl>
// );

// const StatCard = ({
//   title,
//   value,
//   icon,
//   pidx = 0,
//   trend,
//   loading,
//   onClick,
// }) => {
//   const p = CARD_PALETTES[pidx] || CARD_PALETTES[0];
//   return (
//     <Zoom in={!loading} style={{ transitionDelay: `${pidx * 90}ms` }}>
//       <Card
//         onClick={onClick}
//         sx={{
//           height: "100%",
//           cursor: onClick ? "pointer" : "default",
//           background: p.bg,
//           border: `1px solid ${p.border}`,
//           boxShadow: `0 8px 32px rgba(60,20,130,0.12), inset 0 1px 0 rgba(255,255,255,0.65)`,
//           position: "relative",
//           overflow: "hidden",
//           animation: `gxFloat 0.55s ease ${pidx * 0.12}s both`,
//           "&:hover": onClick
//             ? {
//                 transform: "translateY(-8px) scale(1.018)",
//                 boxShadow: `0 24px 52px rgba(60,20,130,0.20), 0 0 32px ${p.glow}, inset 0 1px 0 rgba(255,255,255,0.80)`,
//                 border: "1px solid rgba(255,255,255,0.82)",
//               }
//             : {},
//           "&::before": {
//             content: "''",
//             position: "absolute",
//             inset: 0,
//             backgroundImage: p.sparkles.join(", "),
//             pointerEvents: "none",
//           },
//           "&::after": {
//             content: "''",
//             position: "absolute",
//             bottom: 0,
//             left: "12%",
//             width: "76%",
//             height: "1.5px",
//             background: `linear-gradient(90deg, transparent, ${p.shimmer}, transparent)`,
//           },
//         }}
//       >
//         <CardContent
//           sx={{ position: "relative", zIndex: 1, p: { xs: 3, md: 3.5 } }}
//         >
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "flex-start",
//               justifyContent: "space-between",
//               mb: 2.5,
//             }}
//           >
//             <Avatar
//               sx={{
//                 bgcolor: p.iconBg,
//                 color: p.iconCol,
//                 width: 58,
//                 height: 58,
//                 border: `1.5px solid ${p.iconBd}`,
//                 boxShadow: `0 4px 16px rgba(0,0,0,0.08), 0 0 0 5px rgba(255,255,255,0.18)`,
//               }}
//             >
//               {icon}
//             </Avatar>
//             {trend && (
//               <Chip
//                 label={trend}
//                 size="small"
//                 sx={{
//                   bgcolor: trend.includes("+")
//                     ? "rgba(12,175,118,0.22)"
//                     : "rgba(232,62,62,0.22)",
//                   color: trend.includes("+") ? "#056845" : "#c01818",
//                   border: `1px solid ${trend.includes("+") ? "rgba(12,175,118,0.45)" : "rgba(232,62,62,0.45)"}`,
//                   fontWeight: 700,
//                   fontSize: "0.69rem",
//                 }}
//               />
//             )}
//           </Box>
//           {loading ? (
//             <Box>
//               <Skeleton
//                 variant="text"
//                 width="50%"
//                 height={46}
//                 sx={{ bgcolor: "rgba(255,255,255,0.30)" }}
//               />
//               <Skeleton
//                 variant="text"
//                 width="68%"
//                 height={22}
//                 sx={{ bgcolor: "rgba(255,255,255,0.20)" }}
//               />
//             </Box>
//           ) : (
//             <Box>
//               <Typography
//                 sx={{
//                   fontWeight: 800,
//                   color: p.numCol,
//                   mb: 0.5,
//                   lineHeight: 1.1,
//                   fontSize: { xs: "2rem", sm: "2.65rem" },
//                   fontFamily: '"Outfit",sans-serif',
//                 }}
//               >
//                 {value}
//               </Typography>
//               <Typography
//                 sx={{
//                   fontWeight: 600,
//                   color: p.lblCol,
//                   fontSize: "0.92rem",
//                   letterSpacing: "0.01em",
//                 }}
//               >
//                 {title}
//               </Typography>
//             </Box>
//           )}
//         </CardContent>
//       </Card>
//     </Zoom>
//   );
// };

// const ChartPanel = ({
//   title,
//   children,
//   actions,
//   loading,
//   height = 340,
//   icon,
//   accent = "#6f00ff",
// }) => (
//   <Card
//     sx={{
//       height: "100%",
//       display: "flex",
//       flexDirection: "column",

//       background:
//         "linear-gradient(145deg, rgba(255, 255, 255, 0.75), rgba(230,220,255,0.55))",
//       backdropFilter: "blur(34px) saturate(175%)",
//       WebkitBackdropFilter: "blur(34px) saturate(175%)",
//       border: "1px solid rgba(200,180,255,0.5)",

//       boxShadow: "0 8px 38px rgba(80,40,180,0.18)",

//       // position:"relative", overflow:"hidden",
//       // "&::before": {
//       //   content:"''", position:"absolute", top:0, left:"18%", width:"64%", height:"1px",
//       //   background:`linear-gradient(90deg, transparent, ${accent}92, transparent)`,
//       // },
//     }}
//   >
//     <CardContent
//       sx={{ flexGrow: 1, display: "flex", flexDirection: "column", p: 3 }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           mb: 2.5,
//           pb: 2,
//           borderBottom: "1px solid rgba(255,255,255,0.10)",
//           flexWrap: "wrap",
//           gap: 1,
//         }}
//       >
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
//           {icon && (
//             <Avatar
//               sx={{
//                 bgcolor: `${accent}20`,
//                 color: accent,
//                 width: 40,
//                 height: 40,
//                 border: `1px solid ${accent}38`,
//                 boxShadow: `0 0 16px ${accent}25`,
//               }}
//             >
//               {icon}
//             </Avatar>
//           )}
//           <Typography
//             variant="h6"
//             sx={{
//               fontWeight: 700,
//               color: "#000000",
//               fontSize: { xs: "0.87rem", sm: "0.97rem" },
//               lineHeight: 1.3,
//             }}
//           >
//             {title}
//           </Typography>
//         </Box>
//         {actions && (
//           <Box
//             sx={{
//               display: "flex",
//               gap: 1,
//               alignItems: "center",
//               flexWrap: "wrap",
//             }}
//           >
//             {actions}
//           </Box>
//         )}
//       </Box>
//       {loading ? (
//         <Box
//           sx={{
//             flexGrow: 1,
//             display: "flex",
//             flexDirection: "column",
//             justifyContent: "center",
//           }}
//         >
//           <Skeleton
//             variant="rectangular"
//             height={height - 130}
//             sx={{ borderRadius: 2, bgcolor: "rgba(255,255,255,0.07)" }}
//           />
//         </Box>
//       ) : (
//         <Box
//           sx={{
//             flexGrow: 1,
//             display: "flex",
//             flexDirection: "column",
//             minHeight: height - 130,
//           }}
//         >
//           {children}
//         </Box>
//       )}
//     </CardContent>
//   </Card>
// );

// const DashStars = () => (
//   <Box
//     sx={{
//       position: "absolute",
//       inset: 0,
//       pointerEvents: "none",
//       zIndex: -1,
//       overflow: "hidden",
//     }}
//   >
//     {STARS.map((s, i) => (
//       <Box
//         key={i}
//         sx={{
//           position: "absolute",
//           left: `${s.x}%`,
//           top: `${s.y}%`,
//           width: `${s.sz}px`,
//           height: `${s.sz}px`,
//           borderRadius: "50%",
//           background: "#ffffff",
//           boxShadow: `0 0 ${(s.sz * 3.2).toFixed(1)}px rgba(255,255,255,0.95), 0 0 ${(s.sz * 1.6).toFixed(1)}px rgba(255,255,255,0.82)${s.bright ? `, 0 0 ${(s.sz * 7).toFixed(1)}px rgba(255,255,255,0.52)` : ""}`,
//           animation: `gxTwinkle ${s.dr}s ease-in-out ${s.dl}s infinite`,
//         }}
//       />
//     ))}
//   </Box>
// );

// const Atmosphere = () => (
//   <>
//     <Box
//       sx={{
//         position: "absolute",
//         top: "22%",
//         left: "32%",
//         width: "48%",
//         height: "42%",
//         background: `radial-gradient(ellipse,
//         rgba(255,255,255,0.96) 0%,
//         rgba(255,252,255,0.82) 10%,
//         rgba(255,235,248,0.65) 24%,
//         rgba(255,218,242,0.44) 40%,
//         rgba(248,200,255,0.22) 58%,
//         transparent 78%
//       )`,
//         filter: "blur(22px)",
//         pointerEvents: "none",
//         zIndex: -1,
//         animation: "gxCore 5.5s ease-in-out infinite",
//       }}
//     />
//     <Box
//       sx={{
//         position: "absolute",
//         top: "-12%",
//         left: "-20%",
//         width: "102%",
//         height: "65%",
//         background: `linear-gradient(148deg,
//         rgba(255,255,255,0.34) 0%, rgba(255,254,255,0.24) 18%,
//         rgba(248,235,255,0.16) 36%, rgba(235,218,255,0.08) 55%, transparent 75%
//       )`,
//         borderRadius: "50%",
//         transform: "rotate(-18deg)",
//         filter: "blur(14px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxArm1 18s ease-in-out infinite",
//       }}
//     />
//     <Box
//       sx={{
//         position: "absolute",
//         bottom: "-12%",
//         right: "-15%",
//         width: "95%",
//         height: "60%",
//         background: `linear-gradient(148deg,
//         rgba(255,255,255,0.30) 0%, rgba(255,252,255,0.20) 20%,
//         rgba(245,228,255,0.12) 42%, rgba(232,215,255,0.06) 60%, transparent 78%
//       )`,
//         borderRadius: "50%",
//         transform: "rotate(12deg)",
//         filter: "blur(16px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxArm2 22s ease-in-out infinite",
//       }}
//     />
//     <Box
//       sx={{
//         position: "absolute",
//         top: "12%",
//         left: "18%",
//         width: "68%",
//         height: "62%",
//         background: `radial-gradient(ellipse at 52% 48%,
//         rgba(255,235,248,0.48) 0%, rgba(255,222,242,0.30) 28%,
//         rgba(250,210,255,0.15) 52%, transparent 72%
//       )`,
//         filter: "blur(36px)",
//         pointerEvents: "none",
//         zIndex: 1,
//         animation: "gxBreath 9s ease-in-out infinite",
//       }}
//     />

//     <Box
//       sx={{
//         position: "absolute",
//         top: "-10%",
//         right: "-8%",
//         width: "50%",
//         height: "48%",
//         background: `radial-gradient(ellipse,
//         rgba(205,228,255,0.54) 0%, rgba(188,215,255,0.32) 32%,
//         rgba(205,222,255,0.14) 55%, transparent 72%
//       )`,
//         filter: "blur(32px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />
//     <Box
//       sx={{
//         position: "absolute",
//         top: "-5%",
//         left: "-5%",
//         width: "40%",
//         height: "44%",
//         background: `radial-gradient(ellipse,
//         rgba(108,62,185,0.58) 0%, rgba(122,78,200,0.34) 36%, transparent 64%
//       )`,
//         filter: "blur(30px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />

//     <Box
//       sx={{
//         position: "absolute",
//         bottom: "-5%",
//         left: "8%",
//         width: "58%",
//         height: "32%",
//         background: `radial-gradient(ellipse,
//         rgba(198,148,250,0.40) 0%, rgba(210,165,255,0.22) 42%, transparent 68%
//       )`,
//         filter: "blur(30px)",
//         pointerEvents: "none",
//         zIndex: 1,
//       }}
//     />
//   </>
// );
// const DashboardPage = () => {
//   const [loading, setLoading] = useState(false);
//   const [totalMyDocs, setTotalMyDocs] = useState(0);
//   const [totalSharedDocs, setTotalSharedDocs] = useState(0);
//   const [imageCardData, setImageCardData] = useState({
//     totalDocuments: "0",
//     pendingForApproval: "0",
//     unreadMsgCount: "0",
//   });

//   const userDetails = useSelector((s) => s.user);
//   const isGuest = localStorage.getItem("is_guest");
//   const userID = userDetails?.currentUser?._id;

//   const [yearList, setYearList] = useState(() => {
//     const c = new Date().getFullYear();
//     return Array.from({ length: c - 2018 }, (_, i) => ({
//       name: `${2019 + i}`,
//       value: 2019 + i,
//     }));
//   });
//   const [barChartYear, setBarChartYear] = useState(new Date().getFullYear());
//   const [statusChartYear, setStatusChartYear] = useState(
//     new Date().getFullYear(),
//   );
//   const [isBarChartDropdown, setIsBarChartDropdown] = useState(false);
//   const [isPieChartDropdown, setIsPieChartDropdown] = useState(false);
//   const [teamList, setTeamList] = useState([]);
//   const [selectedMember, setSelectedMember] = useState();
//   const [barChartData, setBarChartData] = useState({
//     bar1Count: 0,
//     bar2Count: 0,
//     bar1Name: "Documents(0)",
//     bar2Name: "Reviews(0)",
//     xAxis: [
//       "Jan",
//       "Feb",
//       "Mar",
//       "Apr",
//       "May",
//       "June",
//       "July",
//       "Aug",
//       "Sept",
//       "Oct",
//       "Nov",
//       "Dec",
//     ],
//     bar1Datas: [],
//     bar2Data: [],
//   });
//   const [barDocsStatusData, setBarDocsStatusData] = useState({
//     xAxis: ["Pending", "Progress", "Completed", "Rejected", "Published"],
//     counts: [],
//   });
//   const [notifications, setNotifications] = useState([]);
//   const [alertForEndSub, setAlertForEndSub] = useState("");
//   const [showPopup, setShowPopup] = useState(false);

//   const screenData = useSelector(
//     (s) => s.manageSubscriptionPlan?.subscriptionPlan,
//   );

//   useEffect(() => {
//     if (isGuest) {
//       setTotalMyDocs(12);
//       setTotalSharedDocs(4);
//       setImageCardData({
//         totalDocuments: "16",
//         pendingForApproval: "3",
//         unreadMsgCount: "5",
//       });
//       setBarChartData((p) => ({
//         ...p,
//         bar1Datas: [2, 3, 4, 5, 6, 4, 3, 2, 1, 3, 5, 4],
//         bar2Data: [1, 2, 1, 2, 3, 2, 1, 1, 2, 2, 3, 2],
//         bar1Count: 42,
//         bar2Count: 22,
//         bar1Name: "Documents(42)",
//         bar2Name: "Reviews(22)",
//       }));
//       setBarDocsStatusData((p) => ({ ...p, counts: [3, 5, 8, 2, 6] }));
//     }
//   }, [isGuest]);

//   useEffect(() => {
//     const shown = sessionStorage.getItem("subscriptionAlertShown"),
//       role = sessionStorage.getItem("Role");
//     if (!shown && screenData?.isDefault === false && role === "Individual") {
//       const now = moment().startOf("day"),
//         exp = moment(screenData?.endDate).startOf("day"),
//         days = exp.diff(now, "days");
//       if (days >= 1 && days <= 5) {
//         setAlertForEndSub(
//           `Your subscription will expire in ${days} day(s) on ${exp.format("D MMMM YYYY")}.`,
//         );
//         setShowPopup(true);
//       } else if (days === 0) {
//         setAlertForEndSub(
//           `Your subscription expires today on ${exp.format("D MMMM YYYY")}.`,
//         );
//         setShowPopup(true);
//       }
//       if ((days >= 1 && days <= 5) || days === 0)
//         sessionStorage.setItem("subscriptionAlertShown", "true");
//     }
//   }, [screenData?.endDate]);

//   // Year list
//   useEffect(() => {
//     const c = new Date().getFullYear(),
//       arr = Array.from({ length: c - 2018 }, (_, i) => ({
//         name: `${2019 + i}`,
//         value: 2019 + i,
//       }));
//     setYearList(arr);
//     setIsBarChartDropdown(true);
//   }, []);

//   useEffect(() => {
//     if (!isGuest) {
//       fetchYearList();
//       getUserDashCards();
//       getUserBarChart(barChartYear);
//     }
//   }, [isGuest]);

//   const fetchYearList = async () => {
//     try {
//       const r = await DashboardServices.getYearList();
//       if (r.status === 200) {
//         const c = new Date().getFullYear(),
//           s = r.yearList || [];
//         if (!s.includes(c)) {
//           s.push(c);
//           s.sort((a, b) => a - b);
//         }
//         setYearList(s.map((y) => ({ name: `${y}`, value: y })));
//         setIsBarChartDropdown(true);
//       }
//     } catch {
//       const c = new Date().getFullYear(),
//         a = Array.from({ length: c - 2018 }, (_, i) => ({
//           name: `${2019 + i}`,
//           value: 2019 + i,
//         }));
//       setYearList(a);
//       setIsBarChartDropdown(true);
//     }
//   };

//   const fetchTeamList = async () => {
//     try {
//       const r = await DashboardServices.getTeamMembersDetails(userID);
//       setTeamList(r.memberNames.map((o) => ({ name: o.name, value: o.id })));
//       setIsPieChartDropdown(true);
//     } catch {}
//   };
//   const getDocs = async () => {
//     try {
//       const r = await documentService.getAllMyDocuments();
//       if (r.status === 200) setTotalMyDocs(r.data.length);
//     } catch {}
//   };
//   const getSharedDocs = async () => {
//     try {
//       const r = await documentService.getSharedDocuments();
//       if (r.status === 200) setTotalSharedDocs(r.data.length);
//     } catch {}
//   };
//   useEffect(() => {
//     if (!isGuest) {
//       getDocs();
//       getSharedDocs();
//     }
//   }, [isGuest]);

//   const getUserDashCards = async () => {
//     setLoading(true);
//     try {
//       const r = await DashboardServices.getIndividualDashCards(userID);
//       setImageCardData({
//         totalDocuments: r.totalDocuments,
//         pendingForApproval: r.pendingForApproval,
//         unreadMsgCount: r.unreadMsgCount,
//       });
//     } catch {}
//     setLoading(false);
//   };
//   const getUserBarChart = async (y) => {
//     setLoading(true);
//     try {
//       const r = await DashboardServices.getIndividualBarChart(userID, y);
//       setBarChartData((p) => ({
//         ...p,
//         bar1Datas: r.bar1,
//         bar2Data: r.bar2,
//         bar1Count: r.bar1Count,
//         bar2Count: r.bar2Count,
//         bar1Name: `Documents(${r.bar1Count})`,
//         bar2Name: `Reviews(${r.bar2Count})`,
//       }));
//     } catch {}
//     setLoading(false);
//   };
//   const fetchStatus = async (y = statusChartYear) => {
//     try {
//       const r = await DashboardServices.getDocsStatusBarChart(userID, y);
//       setBarDocsStatusData((p) => ({ ...p, counts: r.counts }));
//     } catch {}
//   };
//   useEffect(() => {
//     if (!isGuest) fetchStatus();
//   }, [isGuest]);

//   const handleBarYear = (y) => {
//     if (y > new Date().getFullYear()) {
//       toast.warn("Please enter current or past year");
//       return;
//     }
//     getUserBarChart(y);
//   };
//   const handleStatusYear = (y) => {
//     if (y > new Date().getFullYear()) {
//       toast.warn("Please enter current or past year");
//       return;
//     }
//     setStatusChartYear(y);
//     fetchStatus(y);
//   };
//   const fetchNotifs = async () => {
//     try {
//       setNotifications((await getnotifications()) || []);
//     } catch {
//       setNotifications([]);
//     }
//   };
//   useEffect(() => {
//     if (!isGuest) fetchNotifs();
//   }, [isGuest]);

//   const stats = [
//     {
//       title: "Total Documents",
//       value: String(totalMyDocs + totalSharedDocs) || "0",
//       icon: <DocumentIcon />,
//       pidx: 0,
//       link: "/mydocuments",
//     },
//     {
//       title: "Pending Approval",
//       value: imageCardData.pendingForApproval || "0",
//       icon: <PendingIcon />,
//       pidx: 1,
//       link: "/mydocuments",
//     },
//     {
//       title: "Workspace Chats",
//       value: imageCardData.unreadMsgCount || "0",
//       icon: <ChatIcon />,
//       pidx: 2,
//       link: "/chat",
//     },
//   ];

//   const quickActions = [
//     {
//       label: "View All Documents",
//       icon: <DocumentIcon />,
//       to: "/mydocuments",
//       bg: "rgba(95,148,255,0.22)",
//       border: "rgba(79, 143, 227, 0.66)",
//       hover: "rgba(91, 140, 238, 0.63)",
//     },
//     {
//       label: "Pending Approvals",
//       icon: <PendingIcon />,
//       to: "/mydocuments",
//       bg: "rgba(205,85,48,0.26)",
//       border: "rgba(255,148,108,0.58)",
//       hover: "rgba(219, 88, 48, 0.61)",
//     },
//     {
//       label: "Open Chat",
//       icon: <ChatIcon />,
//       to: "/chat",
//       bg: "rgba(12,152,118,0.26)",
//       border: "rgba(68,215,175,0.58)",
//       hover: "rgba(14, 196, 150, 0.55)",
//     },
//     {
//       label: "Settings",
//       icon: <SettingsIcon />,
//       to: "/accountsettings",
//       bg: "rgba(175,45,205,0.24)",
//       border: "rgba(196, 84, 224, 0.64)",
//       hover: "rgba(176, 45, 205, 0.67)",
//     },
//   ];

//   if (!isGuest && !userID) return <Loader loading={true} />;

//   return (
//     <>
//       <ThemeProvider theme={theme}>
      
//         <Box id="dashboard-page">
//           {/* <DashGlobals /> */}
//           <Box
//             id="dashboard-galaxy-bg"
//             sx={{
//               position: "relative",
//               minHeight: "100vh",
//               overflow: "hidden",
//               background: GALAXY_BG,
//               isolation: "isolate",
//                color: "#ffffff",
//             }}
//           >
//             <DashStars />
//             <Atmosphere />
//             <Box
//               sx={{
//                 position: "relative",
//                 zIndex: 2,
//                 p: { xs: 2, md: 3, lg: 4 },
//               }}
//             >
//               <ToastContainer
//                 toastStyle={{
//                   background: "rgba(42,10,112,0.97)",
//                   border: "1px solid rgba(210,175,255,0.24)",
//                   color: "#f5eeff",
//                   backdropFilter: "blur(22px)",
//                 }}
//               />
//               <Loader loading={loading} />

//               <Box sx={{ mb: { xs: 3, md: 4 } }}>
//                 <Typography
//                   variant="h4"
//                   sx={{
//                     fontWeight: 800,
//                     color: "#fff",
//                     mb: 0.75,
//                     textShadow: "0 2px 24px rgba(120,60,215,0.70)",
//                     fontSize: { xs: "1.72rem", md: "2.18rem" },
//                   }}
//                 >
//                   Dashboard Analytics
//                 </Typography>
//                 <Typography
//                   sx={{
//                     color: "rgba(255,248,255,0.80)",
//                     fontWeight: 400,
//                     fontSize: "0.94rem",
//                   }}
//                 >
//                   Welcome back! Here's what's happening with your documents
//                   today.
//                 </Typography>
//               </Box>

//               {/* Stat cards */}
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 {stats.map((s, i) => (
//                   <Grid xs={12} sm={6} md={4} key={i}>
//                     <Link to={s.link} style={{ textDecoration: "none" }}>
//                       <StatCard
//                         title={s.title}
//                         value={s.value}
//                         icon={s.icon}
//                         pidx={s.pidx}
//                         loading={loading}
//                         onClick={() => {}}
//                       />
//                     </Link>
//                   </Grid>
//                 ))}
//               </Grid>

//               {/* Chart panels */}
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 <Grid xs={12} lg={5}>
//                   <ChartPanel
//                     title="Documents & Reviews Status"
//                     loading={loading}
//                     height={320}
//                     icon={<AssessmentIcon />}
//                     accent="#eea360"
//                     actions={
//                       isBarChartDropdown && (
//                         <Stack direction="row" spacing={1} alignItems="center">
//                           <Chip
//                             label="Status"
//                             size="small"
//                             sx={{
//                               bgcolor: "rgba(245,160,85,0.22)",
//                               color: "#fb7500",
//                               border: "1px solid rgba(245,160,85,0.42)",
//                               fontSize: "0.70rem",
//                               fontWeight: 600,
//                             }}
//                           />
//                           <YearSelect
//                             value={statusChartYear}
//                             onChange={(e) => handleStatusYear(e.target.value)}
//                             yearList={yearList}
//                             accent="#5a2ede"
//                           />
//                         </Stack>
//                       )
//                     }
//                   >
//                     <StatusApexChartsComp
//                       chartHeading=""
//                       cmp1={barChartData.bar1Name}
//                       cmp2={barChartData.bar2Name}
//                       bar1={barDocsStatusData.counts}
//                       xAxisList={barDocsStatusData.xAxis}
//                       isSelectDropdownShown={false}
//                       barChartSelectOptions={yearList}
//                       barChartValue={statusChartYear}
//                       barChartSelectLabel="Year"
//                       isDarkMode={true}
//                     />
//                   </ChartPanel>
//                 </Grid>

//                 <Grid xs={12} lg={7}>
//                   <ChartPanel
//                     title="Documents & Reviews Analytics"
//                     loading={loading}
//                     height={320}
//                     icon={<TimelineIcon />}
//                     accent="#8f3cfc"
//                     actions={
//                       <Stack
//                         direction="row"
//                         spacing={1}
//                         alignItems="center"
//                         flexWrap="wrap"
//                         gap={1}
//                       >
//                         <Chip
//                           label={`Docs: ${barChartData.bar1Count}`}
//                           size="small"
//                           sx={{
//                             bgcolor: "rgba(192,144,255,0.22)",
//                             color: "#834cdb",
//                             border: "1px solid rgba(192,144,255,0.42)",
//                             fontSize: "0.70rem",
//                             fontWeight: 600,
//                           }}
//                         />
//                         <Chip
//                           label={`Reviews: ${barChartData.bar2Count}`}
//                           size="small"
//                           sx={{
//                             bgcolor: "rgba(228,108,240,0.22)",
//                             color: "#793fe4",
//                             border: "1px solid rgba(228,108,240,0.42)",
//                             fontSize: "0.70rem",
//                             fontWeight: 600,
//                           }}
//                         />
//                         {isBarChartDropdown && (
//                           <YearSelect
//                             value={barChartYear}
//                             onChange={(e) => {
//                               setBarChartYear(e.target.value);
//                               handleBarYear(e.target.value);
//                             }}
//                             yearList={yearList}
//                             accent="#c090ff"
//                           />
//                         )}
//                         <GalaxyTip title="Refresh" arrow>
//                           <IconButton
//                             size="small"
//                             onClick={() => getUserBarChart(barChartYear)}
//                             sx={{
//                               color: "#8e38ff",
//                               border: "1px solid rgba(192,144,255,0.34)",
//                               width: 34,
//                               height: 34,
//                               background: "rgba(192,144,255,0.12)",
//                               "&:hover": {
//                                 background: "rgba(192,144,255,0.28)",
//                                 transform: "rotate(180deg)",
//                                 borderColor: "rgba(192,144,255,0.68)",
//                               },
//                               transition: "all 0.4s ease",
//                             }}
//                           >
//                             <RefreshIcon fontSize="small" />
//                           </IconButton>
//                         </GalaxyTip>
//                       </Stack>
//                     }
//                   >
//                     <Box
//                       sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         height: "100%",
//                         flexDirection: "column",
//                         gap: 2,
//                       }}
//                     >
//                       <BarChartIcon
//                         sx={{ fontSize: 62, color: "rgba(192,144,255,0.32)" }}
//                       />
//                       <Typography
//                         sx={{
//                           color: "rgba(255,248,255,0.42)",
//                           fontSize: "0.87rem",
//                         }}
//                       >
//                         Chart data will be displayed here
//                       </Typography>
//                     </Box>
//                   </ChartPanel>
//                 </Grid>
//               </Grid>

//               {/* Notifications */}
//               {notifications.length > 0 && (
//                 <Grid container spacing={3} sx={{ mb: 4 }}>
//                   <Grid xs={12}>
//                     <Card
//                       sx={{
//                         background: "rgba(55,18,135,0.50)",
//                         backdropFilter: "blur(24px)",
//                         border: "1px solid rgba(95,220,192,0.28)",
//                       }}
//                     >
//                       <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
//                         <Box
//                           sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             gap: 1.5,
//                             mb: 3,
//                           }}
//                         >
//                           <Avatar
//                             sx={{
//                               bgcolor: "rgba(95,220,192,0.18)",
//                               color: "#50c8a5",
//                               width: 38,
//                               height: 38,
//                               border: "1px solid rgba(95,220,192,0.34)",
//                             }}
//                           >
//                             <NotifIcon fontSize="small" />
//                           </Avatar>
//                           <Typography
//                             variant="h6"
//                             sx={{ fontWeight: 700, color: "#78e5d2" }}
//                           >
//                             Recent Notifications
//                           </Typography>
//                         </Box>
//                         {notifications.map((n, i) => (
//                           <Alert
//                             key={i}
//                             severity="info"
//                             sx={{
//                               mb: 2,
//                               borderRadius: 2,
//                               background: "rgba(95,220,192,0.10)",
//                               border: "1px solid rgba(95,220,192,0.24)",
//                               color: "#dcf8f2",
//                               "& .MuiAlert-icon": { color: "#50c8a5" },
//                             }}
//                           >
//                             {n.message || "New notification"}
//                           </Alert>
//                         ))}
//                       </CardContent>
//                     </Card>
//                   </Grid>
//                 </Grid>
//               )}

//               {/* Quick actions — pill buttons matching Image 2 bottom row */}
//               <Grid container spacing={3} sx={{ mb: 4 }}>
//                 <Grid xs={12}>
//                   <Card
//                     sx={{
//                       background: "rgba(55,18,135,0.46)",
//                       backdropFilter: "blur(26px)",
//                       border: "1px solid rgba(255,255,255,0.20)",
//                     }}
//                   >
//                     <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
//                       <Box
//                         sx={{
//                           display: "flex",
//                           alignItems: "center",
//                           gap: 1.5,
//                           mb: 3.5,
//                         }}
//                       >
//                         <Avatar
//                           sx={{
//                             bgcolor: "rgba(192,144,255,0.20)",
//                             color: "#c090ff",
//                             width: 38,
//                             height: 38,
//                             border: "1px solid rgba(192,144,255,0.38)",
//                           }}
//                         >
//                           <DashboardIcon fontSize="small" />
//                         </Avatar>
//                         <Typography
//                           variant="h6"
//                           sx={{ fontWeight: 700, color: "#000000" }}
//                         >
//                           Quick Actions
//                         </Typography>
//                       </Box>
//                       <Grid container spacing={2}>
//                         {quickActions.map((a, i) => (
//                           <Grid xs={12} sm={6} md={3} key={i}>
//                             <Button
//                               variant="outlined"
//                               fullWidth
//                               startIcon={a.icon}
//                               component={Link}
//                               to={a.to}
//                               sx={{
//                                 py: 1.8,
//                                 borderRadius: 3,
//                                 borderColor: a.border,
//                                 color: "#7d43f1",
//                                 background: a.bg,
//                                 backdropFilter: "blur(14px)",
//                                 fontWeight: 600,
//                                 fontSize: "0.87rem",
//                                 "&:hover": {
//                                   background: a.hover,
//                                   borderColor: "rgba(255,255,255,0.75)",
//                                   transform: "translateY(-4px)",
//                                   boxShadow: "0 14px 32px rgba(45,10,130,0.24)",
//                                 },
//                               }}
//                             >
//                               {a.label}
//                             </Button>
//                           </Grid>
//                         ))}
//                       </Grid>
//                     </CardContent>
//                   </Card>
//                 </Grid>
//               </Grid>

//               {/* Subscription dialog */}
//               <Dialog
//                 open={showPopup}
//                 onClose={() => setShowPopup(false)}
//                 PaperProps={{
//                   sx: {
//                     borderRadius: 4,
//                     minWidth: { xs: "90%", sm: "500px" },
//                     background: "rgba(35,8,98,0.98)",
//                     backdropFilter: "blur(36px)",
//                     border: "1px solid rgba(238,90,90,0.38)",
//                     boxShadow: "0 25px 80px rgba(0,0,0,0.58)",
//                   },
//                 }}
//               >
//                 <DialogTitle
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     pb: 2,
//                     borderBottom: "1px solid rgba(255,255,255,0.10)",
//                   }}
//                 >
//                   <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
//                     <Avatar
//                       sx={{
//                         bgcolor: "rgba(238,90,90,0.18)",
//                         color: "#f87070",
//                         width: 44,
//                         height: 44,
//                         border: "1px solid rgba(238,90,90,0.34)",
//                       }}
//                     >
//                       <NotifIcon />
//                     </Avatar>
//                     <Typography
//                       variant="h6"
//                       sx={{ fontWeight: 700, color: "#f87070" }}
//                     >
//                       Subscription Plan Alert
//                     </Typography>
//                   </Box>
//                   <IconButton
//                     onClick={() => setShowPopup(false)}
//                     size="small"
//                     sx={{
//                       color: "rgba(235,218,255,0.52)",
//                       "&:hover": { color: "#f87070" },
//                     }}
//                   >
//                     <CloseIcon />
//                   </IconButton>
//                 </DialogTitle>
//                 <DialogContent sx={{ pt: 3, pb: 2 }}>
//                   <Alert
//                     severity="warning"
//                     sx={{
//                       mb: 3,
//                       borderRadius: 3,
//                       background: "rgba(238,130,45,0.10)",
//                       border: "1px solid rgba(238,130,45,0.34)",
//                       color: "#fdba72",
//                       "& .MuiAlert-icon": { color: "#e87025" },
//                     }}
//                   >
//                     {alertForEndSub}
//                   </Alert>
//                   <Typography
//                     sx={{ color: "rgba(235,218,255,0.74)", lineHeight: 1.75 }}
//                   >
//                     Please consider renewing your subscription to continue
//                     enjoying all premium features.
//                   </Typography>
//                 </DialogContent>
//                 <DialogActions sx={{ p: 3, pt: 1, gap: 2 }}>
//                   <Button
//                     onClick={() => setShowPopup(false)}
//                     variant="outlined"
//                     sx={{
//                       borderRadius: 2,
//                       px: 3,
//                       fontWeight: 600,
//                       borderColor: "rgba(255,255,255,0.22)",
//                       color: "rgba(235,218,255,0.74)",
//                       "&:hover": { borderColor: "rgba(255,255,255,0.45)" },
//                     }}
//                   >
//                     Remind Later
//                   </Button>
//                   <Button
//                     onClick={() => setShowPopup(false)}
//                     variant="contained"
//                     sx={{
//                       borderRadius: 2,
//                       px: 3,
//                       fontWeight: 600,
//                       background: "linear-gradient(135deg,#bc1515,#ef6868)",
//                       boxShadow: "0 4px 18px rgba(238,90,90,0.38)",
//                       "&:hover": {
//                         boxShadow: "0 8px 28px rgba(238,90,90,0.50)",
//                         transform: "translateY(-2px)",
//                       },
//                     }}
//                   >
//                     View Plans
//                   </Button>
//                 </DialogActions>
//               </Dialog>
//             </Box>
//           </Box>
//         </Box>
//       </ThemeProvider>
//     </>
//   );
// };

// export default DashboardPage;


